import {
  Button,
  Checkbox,
  Divider,
  Dropdown,
  Form,
  Input,
  InputNumber,
  List,
  MenuProps,
  message,
  Modal,
  notification,
  Splitter,
  Table,
  Tabs,
  Tag,
  Typography,
  Tooltip,
  Drawer,
  Popover,
  Select,
  TabsProps,
  Empty,
  Alert,
  Badge,
  Space,
  Avatar,
  Popconfirm,
  Switch,
} from "antd";
import { Fragment, useEffect, useMemo, useState, useRef, useCallback } from "react";
import "./ApplicationItem.module.css";
import { ApiService } from "api/api.service";
import {
  TbArrowsExchange,
  TbBuildingBank,
  TbCalculator,
  TbCheck,
  TbChessKnight,
  TbChevronLeft,
  TbChevronRight,
  TbCopy,
  TbDots,
  TbDotsVertical,
  TbEdit,
  TbFileInvoice,
  TbInfoCircle,
  TbMail,
  TbNote,
  TbPhone,
  TbPlugConnected,
  TbPlus,
  TbRefresh,
  TbReload,
  TbTable,
  TbTax,
  TbUser,
  TbUpload,
  TbLoader2,
  TbGraph,
  TbEye,
  TbAlertCircle,
  TbTrash,
  TbFileText,
  TbTransactionDollar,
  TbEyeDollar,
  TbSend,
  TbClipboardCheck,
  TbCircleCheck,
  TbFile,
  TbTools,
  TbDeviceMobile,
  TbDeviceDesktop,
  TbColumns3,
  TbX,
  TbRestore,
  TbSignature,
  TbUsersGroup,
  TbAnalyze,
  TbFiles,
  TbInbox,
  TbClock,
  TbSparkles,
  TbMinimize,
  TbMaximize,
  TbAutomation,
  TbReportAnalytics,
  TbListDetails,
  TbBell,
  TbCreditCardPay,
  TbHeadset,
} from "react-icons/tb";
import { RiArrowDownSLine } from "react-icons/ri";

import {
  Area,
  Brush,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  delay,
  formatDate,
  formatDateTime,
  formatMoney,
  fuzzyMatch,
  getErrorMessage,
  getLifeCycleStageColor,
  normalizeCashflowData,
  phoneFormatter,
  toTitleCase,
  transformAndCombineDataForRecharts,
  validateRequiredFields,
} from "utils/functions";

import PageTitle from "components/PageTitle";
import { loaderSm, SingleQueryWrapper } from "components/QueryWrapper";
import {
  ApplicationType,
  AutopayStatus,
  BankFetchMethod,
  BusinessInfo,
  ClientDetails,
  PlaidConnectionStatus,
  SelectedBank,
  StrategySource,
  StrategyType,
  T_Form,
} from "dtos/application.dto";

import { CashFlowData, CashFlowResponse, ForecastTypes } from "dtos/forecast.dto";
import DashboardLayout from "layout/DashboardLayout";
import {
  BusinessInfo as BusinessInfoComponent,
  StrategyPlanDetails,
} from "pages/Dashboard/components/LeadSiderContent";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  BankModal,
  BusinessInfoUpdateModal,
  ChangeStatusModal,
  EditableLedgerModal,
  GraphLoader,
  PandaDocModal,
  PaymentLedger,
  PaymentModal,
  ResetModal,
  UploadLawSuitsModal,
  UploadLoanModal,
  UploadLoanModalProps,
  ViewFileBanks,
  ViewFileBtn,
  ViewFileLawsuits,
  ViewFileLink,
  WalletTopupModal,
  WalletTopupWidget,
} from "./ApplicationItem.components";
// import { currentData, foreCastedData, sortByDate, transformDataForRecharts } from "./data";
import TextNumeric from "components/TextNumeric";
import dayjs from "dayjs";
import CustomModal from "components/CustomStrategy/CustomModal";
import { queryClient } from "utils/queryClient";
import FCDSLens from "components/FCDSLens";
import { ItemType } from "antd/es/menu/interface";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./ApplicationItem.module.scss";
import { useAppSelector } from "store";
import { RoleTypes } from "dtos/user.dto";
import PlaidIcon from "components/PlaidIcon";
import RichTextEditor from "components/RichTextEditor";
import { LuChartLine } from "react-icons/lu";

import { CreditorMatchSync, FREQUENCY_TYPES, LoanSchemaDto, OCR_STATUS } from "dtos/loan.dto";
import { T_Populate, T_MongoId } from "types/_utils.types";
import { FileSchemaDto } from "dtos/file.dto";
import { BankSchemaDto } from "dtos/bank.dto";
import { number } from "zod";

import { BoardResource } from "dtos/kanban.dto";
import RiskReport from "components/RiskReport";
import { LogNavigator } from "pages/TransactionLogs/LogNavigator";
import { WalletTypes } from "dtos/wallet.dto";
import PaymentMethodModal from "components/PaymentMethodModal";
import { EditOutlined, InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { SectionError } from "components/Errors/SectionError";
import { StartPaymentAutomationModal } from "components/PaymentJobs/StartPaymentAutomationModal";
import { ControlPaymentAutomation } from "components/PaymentJobs/ControlPaymentAutomation";
import { LEDGER_CATEGORY, TRANSACTION_STATUS } from "dtos/ledger.dto";
import { LoanFrequencyMultiplier } from "../../components/Application/constants";
import { AddLoanModal } from "./LoanAddModal";
import { PaymentComparator } from "../../components/Application/PaymentComparator";
import CopyPDLinks from "components/CopyPDLinks";
import { TeamSection } from "./TeamSection";
import { GetPandaDocFile } from "components/GetPandaDocFile";
import StageSelect from "components/Stages/select";
import { Resource } from "dtos/stage.dto";
import { ExpectedPaymentBreakdown } from "components/Application/reconciliation";
import { ShinyMenuItem } from "components/Application/ShineButton";
import SmartNegotiationPanel from "components/EmailDashboard/SmartNegotiation";
import MissingBankPeriods from "components/MissingBankPeriods";
import { MiscFiles } from "components/MiscFiles/MiscFiles";
import TaskBoardTab from "components/TaskBoard/TaskBoardTab";
import { LoanReconciliationDrawer } from "components/Application/LoanPaymentTimeLine";

const items: MenuProps["items"] = Object.entries(ForecastTypes).map(([key, value]) => {
  return {
    key: value,
    label: toTitleCase(key, { sep: "_", forceLower: true }),
    icon: value === ForecastTypes.REGENERATE_CHARTS ? <TbRefresh /> : null,
  };
});

type TabKeyType = "loans" | "banks" | "ledger" | "agreements" | "forecast" | "notes" | "apr" | "misc-files";

// const foreCastModalName = Object.entries(ForecastTypes).map(([key, value]) => {
//   return toTitleCase(key, { sep: "_", forceLower: true });
// });

const modalTitle: { [key in ForecastTypes]?: string } = {};

const modalTitles = Object.entries(ForecastTypes).forEach(([key, value]) => {
  return (modalTitle[value] = toTitleCase(key, { sep: "_", forceLower: true }));
});

export default function ApplicationItem() {
  const navigate = useNavigate();
  const currentUser = useAppSelector((state) => state.user);
  const [linkCreditorForm] = Form.useForm();
  const [isCopied, setIsCopied] = useState(false);
  const [copyKey, setCopyKey] = useState<"phone" | "email" | "appkey">("phone");
  const [openEditableLedgerModal, setOpenEditableLedgerModal] = useState(false);
  const [openLedgerEditPopover, setOpenLedgerEditPopover] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [ledgerType, setLedgerType] = useState<"weekly" | "monthly">("weekly");
  const [isPandaDocModalOpen, setIsPandaDocModalOpen] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] = useState(false);
  const [isFIADrawerOpen, setIsFIADrawerOpen] = useState(false);
  const [smartNegotiationContext, setSmartNegotiationContext] = useState<{
    application_id?: string;
    loan_id?: string;
    thread_id?: string;
    message_id?: string;
  }>({ application_id: undefined, loan_id: undefined, message_id: undefined, thread_id: undefined });
  const [isNegotiationPanelOpen, setIsNegotiationPanelOpen] = useState(false);
  const [isLoanUploadModalOpen, setIsLoanUploadModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState<UploadLoanModalProps["uploadType"]>("loan");
  const [isBusinessDetailsOpen, setIsBusinessDetailsOpen] = useState(false);
  const [businessInfo, setBusinessInfo] = useState<BusinessInfo | null>(null);
  const [clientDetails, setClientDetails] = useState<ClientDetails | null>(null);
  const [bankDetails, setBankDetails] = useState<SelectedBank | null>(null);
  const [isLawSuitsUploadModalOpen, setIsLawSuitsUploadModalOpen] = useState(false);
  const iframeContainerRef = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [openForeCastedModal, setOpenForeCastedModal] = useState(false);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const appKey = useParams()?.appKey;
  const [openPaymentMethodModal, setOpenPaymentMethodModal] = useState(false);

  const fullApplication = ApiService.application.useGetByAppKey(appKey);
  const chnageOrgQuery = ApiService.upstream.useChangeOrganisation();
  const getAllOrgRes = ApiService.organisation.useGetPaginated({ page: 1, limit: 20 });
  const getAllOrgData = getAllOrgRes.data?.result.data ?? [];

  const orgBelongsTo = getAllOrgData.find((org) => org.slug === fullApplication.data?.application.organisation?.slug);
  const stagesQuery = ApiService.organisation.useGetAllStages(fullApplication.data?.application.organisation?.code, {
    usable: true,
  });
  const firstOutbound = ApiService.negotiation.useFirstOutbound();
  const applicationStages = (stagesQuery.data ?? []).filter((s) => s.resource === Resource.APPLICATION);
  const loanStages = (stagesQuery.data ?? []).filter((s) => s.resource === Resource.LOAN);

  const addCreditor = ApiService.creditor.useCreateCreditor();
  const allCreditors = ApiService.creditor.useGetAllCreditorNames();
  const allCreditorsData = allCreditors.data?.result ?? [];
  const creditorNames = useMemo(
    () =>
      allCreditorsData.map((c) => {
        return {
          name: c.name,
          id: c._id,
          isPartner: c.isPartner,
        };
      }),
    [allCreditorsData],
  );
  const [foreCastModalTitle, setForecastModalTitle] = useState<string | undefined>("");
  const generateAIAuditReport = ApiService.application.useGenerateReport();
  const foreCast = ApiService.forecast.useGetDailyForeCast(appKey);
  const fiaReport = ApiService.application.useGetFIAReport(appKey);
  const generateFIAReport = ApiService.application.useGenerateFIAReport();
  const createPerson = ApiService.communicationChannel.useCreatePerson();
  const checkPersonExistsOrNot = ApiService.communicationChannel.useGetPersonByCorrelation();
  const checkDeskExistsOrNot = ApiService.communicationChannel.useCheckDeskCorrelationExists();
  const [fetchedDeskId, setFetcheDeskId] = useState("");
  const writeNote = ApiService.application.useWriteNote();
  const linkCreditor = ApiService.creditor.useLinkCreditor();
  const [newCreditorName, setNewCreditorName] = useState("");
  const [newPartnerCreditorName, setNewPartnerCreditorName] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const optionsQuery = ApiService.application.useGetDSRiskReportOptions(appKey);
  const runReport = ApiService.application.useGetDSRiskRunReport();
  const consumeCredits = ApiService.credit.useConsumeCredits();
  const [activeKey, setActiveKey] = useState<TabKeyType>(
    tab &&
      ["loans", "banks", "ledger", "agreements", "forecast", "apr", "notes", "team", "tasks", "misc-files"].includes(
        tab,
      )
      ? (tab as TabKeyType)
      : "loans",
  );

  const [openLinkCreditor, setOpenLinkCreditor] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string | undefined>(undefined);

  const [selectedBank, setSelectedBank] = useState<
    | T_Populate<
        BankSchemaDto,
        {
          attachments: FileSchemaDto[];
        }
      >
    | undefined
  >();
  const [openEditBank, setOpenEditBank] = useState(false);
  const [isLoanPaymentTimelineDrawerOpen, setIsLoanPaymentTimelineDrawerOpen] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState<
    | T_Populate<
        LoanSchemaDto,
        {
          attachments: FileSchemaDto[];
        }
      >
    | undefined
  >();
  const [analyzeLoan, setAnalyzeLoan] = useState<Omit<LoanSchemaDto, "attachments"> | undefined>();
  const [openCreditorModal, setOpenCreditorModal] = useState(false);
  const [openPaymentAutomationControlModal, setOpenPaymentAutomationControlModal] = useState(false);
  const syncBalance = ApiService.upstream.useSyncBalance();

  // Inline editing states
  const [editingLoanId, setEditingLoanId] = useState<string | null>(null);
  const [editingField, setEditingField] = useState<
    "funded_amount" | "payback_amount" | "due_amount" | "receivables" | null
  >(null);
  const [editValue, setEditValue] = useState<number | null>(null);
  const editLoan = ApiService.upstream.useEditLoan();

  const postForeCast = ApiService.application.useProcessDebtorSummary(appKey);
  const paymentTable = ApiService.application.useGetPaymentTable(fullApplication?.data?.application?._id);
  //  const postForeCast = ApiService.forecast.usePostForecast();
  const [noteText, setNoteText] = useState(fullApplication?.data?.application?.notes);
  useEffect(() => {
    if (fullApplication?.data?.application?.notes) {
      setNoteText(fullApplication?.data?.application?.notes);
    }
  }, [fullApplication?.data?.application?.notes]);

  const latestPaymentTable = fullApplication.data?.application.payment_table?.at(-1) ?? {
    weeks: paymentTable.data?.payment_table?.at(-1)?.week,
    version: 1,
    created: paymentTable.data?.payment_table.at(0)?.order_date || new Date(),
  };

  latestPaymentTable.weeks = paymentTable.data?.payment_table.reduce((mx, curr) => Math.max(mx, curr.week), 0);

  const isMonthly = paymentTable.data?.payment_table.some((entry) => entry.category === LEDGER_CATEGORY.MONTHLY);
  useEffect(() => {
    if (isMonthly) {
      setLedgerType("monthly");
    }
  }, [isMonthly]);

  const hasEnded =
    fullApplication.data?.application.strategy_type === StrategyType.STANDARD ||
    !paymentTable.data?.payment_table?.at(-1)?.remaining_amount?.total;

  useEffect(() => {
    if (openLinkCreditor) {
      linkCreditorForm.setFieldsValue({
        creditor_id: selectedLoan?.creditor_id,
      });
    }
  }, [openLinkCreditor, selectedLoan, linkCreditorForm]);

  const hasFired = useRef(false);

  useEffect(() => {
    if (!optionsQuery.isSuccess || !fullApplication.isSuccess) return;
    if (!optionsQuery.data || !fullApplication.data) return;
    if (hasFired.current) return;

    hasFired.current = true;

    const body = {
      name: fullApplication.data?.application.meta.client_name || "User",
      email: `auto-${fullApplication.data?.application.app_key}@datasense.mindwebs.co`,
      appkey: fullApplication.data?.application.app_key || "",
      ruleSetIds: optionsQuery.data.result.ruleSetIds,
      aiAuditReportKeys: [], // DO NOT RUN AUDIT REPORT WHEN ITS JUST APR - optionsQuery.data.result.aiAuditReportKeys,
      // loans: fullApplication.data?.data.application.loans ?? [],
      loans: (fullApplication.data?.data.application.loans ?? []).map(
        ({ attachments, ...loan }) => loan, // stripping out attachments.
      ),
    };

    runReport.mutate(
      {
        ...body,
      },
      {
        onSuccess: (res) => {
          // console.log("run report", res.result);
          setIframeUrl(res.result.aprRedirectUrl);
        },
      },
    );
    // consumeCredits.mutate({
    //   appkey: fullApplication.data?.application.app_key,
    //   amount: 1,
    //   credit_type: CreditTypes.AI_AUDIT,
    //   description: "1 credit consumed for generating Auto Insight (APR) Report.",
    //   extra: {
    //     isDSRisk: true,
    //   },
    // });
  }, [optionsQuery.isSuccess, optionsQuery.data, fullApplication.isSuccess, fullApplication.data]);

  useEffect(() => {
    if (foreCast.isSuccess) {
      setUnChangedForeCastData(foreCast.data.result);
    }
  }, [foreCast]);

  const toggleFullscreen = () => {
    if (!iframeContainerRef.current) return;

    if (!document.fullscreenElement) {
      iframeContainerRef.current.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  // keep state in sync when user exits via Esc key too
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);
  // console.log(foreCastModalName);

  // const handleMenuClick: MenuProps["onClick"] = (e) => {
  //   e.key == "2" ? setOpenModal(true) : "";
  // };
  // const menuProps = {
  //   items,
  //   onClick: handleMenuClick,
  // };
  // const getClearApplication = ApiService.onboarding.useGetApplicationById(
  //   fullApplication.data?.application._id as string,
  // );
  // const getClearApplicationData = getClearApplication.data?.result;

  const [foreCastData, setForeCastData] = useState<CashFlowData[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [categoryForeCast, setCategoryForeCast] = useState<CashFlowData[]>([]);
  const [unChangedForeCastData, setUnChangedForeCastData] = useState<CashFlowResponse[]>([]);
  const [selectedForeCastCategory, setSelectedForeCastCategory] = useState<CashFlowData | null>(null);
  const [tabKey, setTabKey] = useState<string>("");
  const [hiddenSeries, setHiddenSeries] = useState<string[]>([]);
  const [openv2Modal, setOpenv2Modal] = useState(false);
  const [dailyv2Data, setDailyv2Data] = useState<any>();
  const chartScrollRef = useRef<HTMLDivElement>(null);
  const [previewHtml, setPreviewHtml] = useState<string | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const { refetch } = ApiService.application.useGetPreviewAgreementPDF(appKey);
  const [topupModal, setTopupModal] = useState(false);
  const initiatePandaDoc = ApiService.upstream.useInitiatePandaDoc();
  const resetPandaDoc = ApiService.upstream.useResetPandaDoc();
  const orgQuery = ApiService.organisation.useGetAllOrganisations();
  const loanPipeline = ApiService.kanban.useGetBoard({
    resource: BoardResource.LOAN,
    scope: BoardResource.APPLICATION,
    orgCode: fullApplication.data?.application.organisation?.code,
  });
  const [openPDLinksModal, setOpenPDLinksModal] = useState(false);
  const [openPaymentAutomationStartModal, setOpenPaymentAutomationStartModal] = useState(false);

  const handleInitiatePandaDoc = async () => {
    initiatePandaDoc.mutate(
      { appkey: appKey },
      {
        onSuccess: (data) => {
          message.success(
            data.message ||
              "PandaDoc generation has started. An email will be sent to the client and cosigners when it's ready.",
          );
        },
      },
    );
  };
  const handleSendFirstOutBound = ({ loanId }: { loanId: string }) => {
    notification.info({
      message: "Generating negotiation context...",
      description: "This may take 5–10 seconds. Please wait while we prepare the details.",
    });
    firstOutbound.mutate(
      {
        body: { appkey: appKey, loan_id: loanId },
      },
      {
        onSuccess: () => {
          setSmartNegotiationContext({ application_id: fullApplication.data?.application._id, loan_id: loanId });
          setIsNegotiationPanelOpen(true);
        },
      },
    );
  };

  const handleResetPandaDoc = async () => {
    resetPandaDoc.mutate(
      { appkey: appKey! },
      {
        onSuccess: (data) => {
          message.success(data.message || "PandaDoc has been reset. The client can now start a new PandaDoc.");
          fullApplication.refetch();
        },
      },
    );
  };

  const handlePreview = async () => {
    const { data, error } = await refetch();

    if (error) {
      const err: any = error;
      const data = JSON.parse(err.response?.data ?? "{}");
      message.error(data?.message ?? "Preview failed to render.");
      return;
    }

    setPreviewHtml(data);
    setIsPreviewOpen(true);
    setIframeKey((k) => k + 1);
  };

  const deleteLoan = ApiService.upstream.useDeleteLoans();

  const existingStrategy = fullApplication.data?.data?.application.strategy?.plan
    ? fullApplication.data?.data?.application.strategy?.plan === "Custom"
      ? 1
      : Number(fullApplication.data?.data?.application.strategy?.plan?.replace("Fixed Plan ", ""))
    : undefined;
  // console.log({ existingStrategy });
  const [selectedPlanIdx, setSelectedPlanIdx] = useState<number | undefined>(
    existingStrategy ? existingStrategy - 1 : undefined,
  );
  // console.log({ plan: fullApplication.data?.data?.application.strategy?.plan });
  // console.log({ selectedPlanIdx });
  // const updateLoanStatus = ApiService.application.useUpdateLoanStatus();
  const updateApplicationStage = ApiService.application.useUpdateStage();
  const updateLoanStage = ApiService.loans.useUpdateStage();
  const loanMapping = ApiService.application.useGetLoansMapping(appKey);
  const getMappedLoanData = useCallback(
    (loanId: T_MongoId) => loanMapping.data?.find((loan) => loan.loan === loanId),
    [loanMapping.data],
  );

  const strategyOrg = useMemo(() => {
    const plan = fullApplication.data?.application.plan;
    if (!plan) return undefined;
    if (plan.custom_payments === true) {
      return { custom: true };
    }

    const org = orgQuery.data?.find((org) => org.strategies?.some((str) => str.slug === plan.slug));
    if (org?.name) {
      return {
        name: org.name,
        logo: org.meta?.favicon,
        custom: false,
      };
    }
  }, [fullApplication.data?.application.plan, orgQuery.data]);

  const toggleSeries = (dataKey: string) => {
    setHiddenSeries((prev) => (prev.includes(dataKey) ? prev.filter((key) => key !== dataKey) : [...prev, dataKey]));
  };
  const [openPaymentModal, setOpenPaymentModal] = useState(false);

  const items: MenuProps["items"] = Object.entries(ForecastTypes).map(([key, value]) => {
    return {
      key: value,
      label: toTitleCase(key, { sep: "_", forceLower: true }),
      icon: value === ForecastTypes.REGENERATE_CHARTS ? <TbRefresh /> : null,
    };
  });

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    // message.info("Click on menu item.");
    // console.log(e);
    if (e.key === ForecastTypes.REGENERATE_CHARTS) {
      postForeCast.mutate(
        { app_key: fullApplication?.data?.application?.app_key as any, type: "forecast" },
        {
          onSuccess: () => {
            notification.info({ message: "Regenerating charts , please come back after 10 minutes" });
          },
        },
      );
      return;
    }
    setForecastModalTitle(modalTitle[e.key as keyof typeof modalTitle]);
    if (e.key === ForecastTypes.CATEGORY) {
      setOpenCategoryModal(true);
      setCategoryForeCast(
        unChangedForeCastData
          .filter((data) => {
            return data.type === ForecastTypes.CATEGORY;
          })
          .flatMap((i) => i.data),
      );
    } else if (e.key === ForecastTypes.CASHFLOW_DAILY_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.CASHFLOW_DAILY_V2;
        }),
      );
    } else if (e.key === ForecastTypes.CATEGORY_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.CATEGORY_V2;
        }),
      );
    } else if (e.key === ForecastTypes.WEEKLY_BALANCE_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.WEEKLY_BALANCE_V2;
        }),
      );
    } else if (e.key === ForecastTypes.CREDIT_DAILY_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.CREDIT_DAILY_V2;
        }),
      );
    } else if (e.key === ForecastTypes.EXPENSE_DAILY_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.EXPENSE_DAILY_V2;
        }),
      );
    } else if (e.key === ForecastTypes.DAILY_BALANCE_V2) {
      setOpenv2Modal(true);
      setDailyv2Data(
        unChangedForeCastData.filter((data) => {
          return data.type === ForecastTypes.DAILY_BALANCE_V2;
        }),
      );
    } else {
      setForeCastData(
        unChangedForeCastData.filter((data) => {
          return data.type === e.key;
        })[0]?.data || [],
      );

      setOpenForeCastedModal(true);
    }

    // if (e.key === ForecastTypes.CASHFLOW_DAILY) {
    // }
  };
  useEffect(() => {
    setTabKey(categoryForeCast[0]?.title || "");
    setSelectedForeCastCategory(categoryForeCast?.[0]);
  }, [categoryForeCast]);

  // console.log({ dailyv2Data });

  const handleChangeTab: TabsProps["onChange"] = (key) => {
    setTabKey(key);
    const selected = categoryForeCast.find((item) => item.title === key) || null;
    setSelectedForeCastCategory(selected);
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };
  const [form] = Form.useForm<T_Form>();
  const check1: T_Form["check1"] = Form.useWatch("check1", form);
  const check2: T_Form["check2"] = Form.useWatch("check2", form);
  const check3: T_Form["check3"] = Form.useWatch("check3", form);
  const check4: T_Form["check4"] = Form.useWatch("check4", form);
  const check5: T_Form["check5"] = Form.useWatch("check5", form);
  const check6: T_Form["check6"] = Form.useWatch("check6", form);
  const check7: T_Form["check7"] = Form.useWatch("check7", form);
  const check8: T_Form["check8"] = Form.useWatch("check8", form);
  const check9: T_Form["check9"] = Form.useWatch("check9", form);
  // console.log("3 ", values);
  const handleSubmitForm = async () => {
    const formData = await form.validateFields();
    // console.log(formData);
  };

  const hasAIReport =
    fullApplication?.data?.application?.intelligence && fullApplication?.data?.application?.intelligence?.length > 0;

  const hasFIAReport = fiaReport.data !== undefined;

  const handlePostForecast = () => {
    postForeCast.mutate(
      { app_key: appKey as any, type: "forecast" },
      {
        onSuccess: () => {
          notification.info({
            message: "We have received your request for generating forecast. Please check back in a few minutes.",
          });
        },
        onError: () => {
          message.error("Forecast generation failed");
        },
      },
    );
  };

  const iconProps = { size: 16 };

  const application = fullApplication.data?.data.application;
  const primaryReportId = fullApplication.data?.application?.intelligence?.[0]?.primary_report;
  const canUseAIAudit = application?.status.loans === true && application?.status.banks === true;
  const isAdmin = currentUser.role === RoleTypes.ADMIN || currentUser.role === RoleTypes.SUPERADMIN;
  const canRetryBank = isAdmin && application?.bank_fetch_via !== BankFetchMethod.PLAID;
  const canStartACH = !!fullApplication.data?.application?.payment_table?.length;

  const pollForAIReport = async () => {
    await delay(5000);
    let attempts = 0;
    const intervalId = setInterval(async () => {
      attempts++;
      const res = await fullApplication.refetch();
      const reportId = res.data?.application?.intelligence?.[0]?.primary_report;
      if (reportId) {
        clearInterval(intervalId);
        notification.success({
          message: (
            <>
              AI audit report generated.{" "}
              <Link to={`/dashboard/application/${appKey}/ai-audit/${reportId}`}>View AI Report</Link>
            </>
          ),
        });
      } else if (attempts > 7) {
        clearInterval(intervalId);
        notification.warning({ message: "Report is taking longer than expected. Check back shortly." });
      }
    }, 5000);
  };

  const handleAIAudit = () => {
    if (!appKey) {
      return message.warning("Application is not selected");
    }
    if (primaryReportId) {
      navigate(`/dashboard/application/${appKey}/ai-audit/${primaryReportId}`);
      return;
    }
    generateAIAuditReport.mutate(
      { app_key: appKey },
      {
        onSuccess: (data) => {
          notification.info({ message: data.message });
          pollForAIReport().catch((error) => message.error(getErrorMessage(error)));
        },
      },
    );
  };

  const openCommunications = () => {
    checkDeskExistsOrNot.mutate(
      { correlationId: fullApplication.data?.application?.organisation?.code as string },
      {
        onSuccess: (desk_res) => {
          // setFetcheDeskId(desk_res.result.desk._id);
          if (desk_res.result.exists) {
            checkPersonExistsOrNot.mutate(
              { correlationId: fullApplication.data?.data.application.app_key as string },
              {
                onSuccess: (res) => {
                  if (res.result.exists) {
                    navigate(
                      `/dashboard/application/${appKey}/communication?person_id=${res.result.person._id}&desk_id=${res.result.person.desk}&src=application&orgCode=${fullApplication.data?.application.organisation?.code}`,
                    );
                  } else {
                    createPerson.mutate(
                      {
                        desk_id: desk_res.result.desk._id,
                        body: {
                          numbers:
                            (fullApplication.data?.data.application?.business_info?.phone ??
                            (fullApplication.data?.application?.meta.phone as string | undefined))
                              ? [
                                  fullApplication.data?.data.application?.business_info?.phone ??
                                    (fullApplication.data?.application?.meta.phone as string),
                                ]
                              : [],
                          emails:
                            (fullApplication.data?.data.application?.business_info?.email ??
                            (fullApplication.data?.application?.meta.email as string | undefined))
                              ? [
                                  fullApplication.data?.data.application?.business_info?.email ??
                                    (fullApplication.data?.application?.meta.email as string),
                                ]
                              : [],
                          correlation_id: fullApplication.data?.data.application.app_key as string,
                          meta: {
                            name:
                              fullApplication.data?.data.application?.client_details?.name ||
                              fullApplication.data?.application.meta.client_name,
                          },
                        },
                      },
                      {
                        onSuccess: (res) => {
                          navigate(
                            `/dashboard/application/${appKey}/communication?person_id=${res.result._id}&desk_id=${res.result.desk}&src=application`,
                          );
                        },
                      },
                    );
                  }
                },
              },
            );
          } else {
            notification.info({
              message: "Desk Required",
              description:
                "This application's organization doesn't have a desk yet. Create a desk first, then proceed to the Communications page.",
            });
          }
        },
      },
    );
  };

  const extraActionsMenu = (): ItemType[] => {
    const go = (path: string) => () => navigate(`/dashboard/application/${appKey}/${path}`);

    const reports: ItemType[] = [
      canUseAIAudit && {
        key: "ai-audit",
        icon: generateAIAuditReport.isPending ? loaderSm : <TbSparkles {...iconProps} />,
        label: generateAIAuditReport.isPending
          ? "Generating AI Audit..."
          : `${hasAIReport ? "View" : "Generate"} AI Audit Report`,
        disabled: generateAIAuditReport.isPending,
        onClick: handleAIAudit,
      },
      {
        key: "fia",
        icon: <TbReportAnalytics {...iconProps} />,
        label: "Financial Impact Analysis",
        onClick: () => setIsFIADrawerOpen(true),
      },
      {
        key: "debtor-summary",
        icon: <TbListDetails {...iconProps} />,
        label: "Debtor Summary",
        onClick: go("debtor-summary"),
      },
    ].filter(Boolean) as ItemType[];

    const communication: ItemType[] = [
      { key: "view-email", icon: <TbMail {...iconProps} />, label: "Send as Merchant", onClick: go("email") },
      {
        key: "communication-channels",
        icon: <TbHeadset {...iconProps} />,
        label: "Talk to Client",
        disabled: checkDeskExistsOrNot.isPending || checkPersonExistsOrNot.isPending || createPerson.isPending,
        onClick: openCommunications,
      },
      { key: "notifications", icon: <TbBell {...iconProps} />, label: "Notifications", onClick: go("notifications") },
    ];

    const payments: ItemType[] = [
      canStartACH && {
        key: "start-ach",
        icon: <TbCreditCardPay {...iconProps} />,
        label: "Start ACH",
        onClick: () => setOpenPaymentModal(true),
      },
      canRetryBank && {
        key: "retry-bank",
        icon: <TbBuildingBank {...iconProps} />,
        label: "Retry Bank Processing",
        disabled: retryMt.isPending,
        onClick: () => retryMt.mutate(appKey!, { onSuccess: () => message.success("Bank processing has restarted.") }),
      },
    ].filter(Boolean) as ItemType[];

    return [
      { type: "group", key: "g-reports", label: "Reports", children: reports },
      { type: "group", key: "g-comms", label: "Communication", children: communication },
      ...(payments.length
        ? [{ type: "group" as const, key: "g-payments", label: "Payments", children: payments }]
        : []),
      { type: "divider" },
      {
        key: "mark-as-signed",
        icon: <TbSignature {...iconProps} />,
        label: "Mark as Signed",
        onClick: () => setIsChangeStatusModalOpen(true),
      },
      {
        key: "reset",
        icon: <TbRestore {...iconProps} />,
        label: "Reset Steps",
        danger: true,
        onClick: () => setIsResetModalOpen(true),
      },
    ];
  };
  const syncBusinessInfo = ApiService.upstream.useSyncInfo();
  const editUpstreamLoan = ApiService.upstream.useEditLoan();
  const relinkPlaid = ApiService.upstream.useRelinkPlaid();
  const renameBankFiles = ApiService.upstream.useRenameBankFiles();
  const deleteBankFiles = ApiService.upstream.useDeleteBankFiles();
  const deleteLawsuit = ApiService.upstream.useDeleteLawsuitFile();

  const retryMt = ApiService.application.useRetryMoneyThumb();
  const [totalLoanBalance, setTotalLoanBalance] = useState(number);
  const [editingBankFileId, setEditingBankFileId] = useState<string | null>(null);
  const [bankAliasDraft, setbankAliasDraft] = useState<Record<string, string>>({});
  const [selectedBankFileIds, setSelectedBankFileIds] = useState<string[]>([]);
  const [deletingLawsuitFileId, setDeletingLawsuitFileId] = useState<string | null>(null);

  const handleLawsuitDeleteFile = (fileId: string, lawsuitId: string) => {
    setDeletingLawsuitFileId(fileId);
    deleteLawsuit.mutate(
      { appkey: appKey!, lawsuit_id: lawsuitId, file_id: fileId },
      {
        onSuccess: () => {
          message.success("Lawsuit file deleted successfully!");
          queryClient.invalidateQueries({ queryKey: ["application", appKey] });
        },
        onSettled: () => {
          setDeletingLawsuitFileId(null);
        },
      },
    );
  };

  const handleBankSaveAlias = (fileId: string) => {
    const alias = bankAliasDraft[fileId];
    if (!alias?.trim()) return;

    renameBankFiles.mutate(
      { appkey: appKey ?? "", files: [{ _id: fileId, alias: alias.trim() }] },
      {
        onSuccess: () => {
          message.success("Files renamed succesfully.");
          setEditingBankFileId(null);
          fullApplication.refetch();
        },
      },
    );
  };

  const handleBankFilesDelete = (fileIds: string[]) => {
    const hideLoading = message.loading("Deleting files — this can take a moment, please wait...", 0);

    deleteBankFiles.mutate(
      { appkey: appKey ?? "", files: fileIds },
      {
        onSuccess: (res) => {
          hideLoading();
          if (res?.result?.failed?.length) {
            message.warning(`${res.result?.deleted?.length ?? 0} deleted, ${res.result?.failed.length} failed.`);
          } else {
            message.success("Files deleted successfully and bank processing restarted.");
          }
          setSelectedBankFileIds([]);
          fullApplication.refetch();
        },
        onError: () => {
          hideLoading();
          message.error("Failed to delete files.");
        },
      },
    );
  };

  // useEffect(()=>{

  // }, [get])

  // useEffect(()=>{

  // }, [get])

  const chipClass = "inline-flex items-center gap-1 rounded-full px-2.5 py-1 bg-gray-100 border border-gray-200";

  const combinedData = useMemo(() => {
    if (foreCastData && foreCastData.length > 0) {
      return transformAndCombineDataForRecharts(foreCastData[0]?.current || [], foreCastData[0]?.forecasted || []);
    }
    return [];
  }, [foreCastData]);
  const combinedCategoryData = useMemo(() => {
    if (selectedForeCastCategory) {
      return transformAndCombineDataForRecharts(
        selectedForeCastCategory?.current || [],
        selectedForeCastCategory?.forecasted || [],
      );
    }
    return [];
  }, [selectedForeCastCategory]);
  const dailyV2DataNomalized = useMemo(() => {
    if (dailyv2Data && dailyv2Data.length > 0) {
      return normalizeCashflowData({
        backTestData: dailyv2Data[0]?.backtest_results?.results || [],
        forecastData: dailyv2Data[0]?.data[0]?.forecasted || [],
        historicalData: dailyv2Data[0]?.data[0]?.current || [],
      });
    }
    return [];
  }, [dailyv2Data]);

  const { historical, backtest, forecast } = dailyV2DataNomalized as any;
  const totalPoints = historical?.length + backtest?.length + forecast?.length;
  // console.log({ historical: historical?.length, backtest: backtest?.length, forecast: forecast?.length });

  // 👇 30–40 px per point is ideal
  const chartWidth = Math.max(totalPoints * 10, 1200);
  // const formatDate = (value: string) => new Date(value).toLocaleDateString();

  const ACTIVE_OCR_STATES = new Set<OCR_STATUS>([OCR_STATUS.PENDING, OCR_STATUS.RUNNING]);

  const isOcrProcessing = (record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    switch (record.ocrState) {
      case OCR_STATUS.PENDING:
      case OCR_STATUS.RUNNING: {
        const diff = dayjs().diff(dayjs(record.createdAt), "minute");
        return diff >= 0 && diff <= 15;
      }

      default:
        return false;
    }
  };

  const isOcrFailed = (record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    if (!record.ocrState) {
      return false;
    }

    if (ACTIVE_OCR_STATES.has(record.ocrState)) {
      return false;
    }

    const diff = dayjs().diff(dayjs(record.createdAt), "minute");
    return record.ocrState === OCR_STATUS.FAILED;
  };
  // console.log({isFaIled: isOcrFailed()})

  useEffect(() => {
    if (!fullApplication?.data?.data?.application?.loans) {
      return;
    }

    const loans = fullApplication.data.data.application.loans;

    let processingLoans = loans.filter((loan) => {
      const diff = dayjs().diff(dayjs(loan.createdAt), "minute");
      return (loan.ocrState === OCR_STATUS.PENDING || loan.ocrState === OCR_STATUS.RUNNING) && diff >= 0 && diff <= 15;
    });

    if (processingLoans.length === 0) {
      return;
    }

    const intervalId = setInterval(async () => {
      try {
        const refetchResult = await fullApplication.refetch();

        if (!refetchResult.data?.data?.application?.loans) {
          return;
        }

        const updatedLoans = refetchResult.data.data.application.loans;

        processingLoans = updatedLoans.filter((loan) => {
          const diff = dayjs().diff(dayjs(loan.createdAt), "minute");
          return (
            (loan.ocrState === OCR_STATUS.PENDING || loan.ocrState === OCR_STATUS.RUNNING) && diff >= 0 && diff <= 15
          );
        });

        // console.log(`${processingLoans.length} loans still processing OCR`);

        if (processingLoans.length === 0) {
          clearInterval(intervalId);
          message.success("All loan processing have been completed!");
        }
      } catch (error) {
        console.error("Error polling OCR status:", error);
      }
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [fullApplication?.data?.data?.application?.loans, appKey]);

  // Handler for starting edit
  const handleStartEdit = (
    loanId: string,
    field: "funded_amount" | "payback_amount" | "due_amount" | "receivables",
    value: number,
  ) => {
    setEditingLoanId(loanId);
    setEditingField(field);
    setEditValue(value);
  };

  // Handler for saving edited value
  const handleSaveEdit = (loan: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    if (!editingLoanId || !editingField || editValue === null) return;

    const DERIVED_LOAN_FIELDS = new Set(["breakeven_amount", "balance_to_totaldebt_percentage", "net_purchase_price"]);
    const NPP_INPUT_FIELDS = new Set(["funded_amount", "origination_fees", "additional_fees_deductions"]);

    const updatedLoan = {
      ...loan,
      [editingField]: editValue,
      attachments: loan?.attachments?.map((el) => el._id),
      manual_overrides:
        DERIVED_LOAN_FIELDS.has(editingField) || NPP_INPUT_FIELDS.has(editingField) ? [editingField] : [],
      autocalculate: true,
    };

    editLoan.mutate(
      {
        appkey: appKey!,
        loan: updatedLoan,
        source: "application-page",
        isFieldsChanged: editingField === "due_amount",
      },
      {
        onSuccess: () => {
          message.success("Loan updated successfully!");
          setEditingLoanId(null);
          setEditingField(null);
          setEditValue(null);
          queryClient.invalidateQueries({ queryKey: ["application", appKey] });
        },
      },
    );
  };

  const handleLoanFrequencyChange = ({
    newFrequency,
    prevFrequency,
    record,
  }: {
    prevFrequency: FREQUENCY_TYPES;
    newFrequency: FREQUENCY_TYPES;
    record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>;
  }) => {
    const payments = record?.payments ?? 0;
    const dailyAmount = payments / LoanFrequencyMultiplier[prevFrequency];
    const newPaybackAmount = dailyAmount * LoanFrequencyMultiplier[newFrequency];

    const updatedLoan = {
      ...record,
      frequency: newFrequency,
      payments: newPaybackAmount,
    };

    editUpstreamLoan.mutate(
      { appkey: appKey!, loan: updatedLoan as any, source: "application-page" },
      {
        onSuccess: () => {
          message.success("Loan frequency updated successfully!");
          queryClient.invalidateQueries({ queryKey: ["application", appKey] });
        },
      },
    );
  };

  // Handler for canceling edit
  const handleCancelEdit = () => {
    setEditingLoanId(null);
    setEditingField(null);
    setEditValue(null);
  };

  const paymentReadinessApplication = () => {
    const adminApp = fullApplication.data?.application;
    const gcApp = fullApplication.data?.data.application;

    return {
      unlinkedLoans: gcApp?.loans.some((l) => !l.creditor_id),
      unlinkedPartnerCreditors: gcApp?.loans.some((l) => !l.partner_creditor_id),
      pandaDocComplete: gcApp?.status.signatures === true,
      hasPaymentMethods: adminApp?.payment_info?.length !== 0,
    };
  };

  return (
    <DashboardLayout
      headerRight={
        <div className="inline-flex gap-2">
          <RiskReport
            name={fullApplication.data?.application.meta.client_name || "User"}
            email={
              fullApplication.data?.application.meta.email ||
              `${fullApplication.data?.application.app_key}.datasense@mindwebs.org`
            }
            appkey={fullApplication.data?.application.app_key || ""}
            loans={fullApplication.data?.data.application.loans ?? []}
          />
          {unChangedForeCastData.length === 0 ? (
            <Button onClick={handlePostForecast} variant="solid" color="magenta">
              Generate Forecast
            </Button>
          ) : // <Dropdown menu={menuProps}>
          //   <Button variant="solid" color="default">
          //     Forecast Data
          //   </Button>
          // </Dropdown>
          null}
          <Link to={`/dashboard/application/${appKey}/calculator`} style={{ height: "fit-content", lineHeight: 1.5 }}>
            <Button color="primary" variant="solid" icon={<TbCalculator />}>
              Calculator
            </Button>
          </Link>
          {/* <Button variant="solid" color="geekblue" onClick={() => setIsOpen(true)} icon={<TbChessKnight />}>
            Custom Strategies
          </Button> */}
          {/* {fullApplication?.data &&
          fullApplication?.data?.application?.payment_table &&
          fullApplication?.data?.application?.payment_table?.length > 0 ? (
            <Button
              onClick={() => setOpenPaymentModal(true)}
              color="green"
              variant="solid"
              icon={<TbPlayerPlayFilled />}
              className="!bg-green-600"
            >
              Start ACH
            </Button>
          ) : null} */}
          <FCDSLens appKey={appKey} aiIntelSummary={fullApplication?.data?.application?.ai_intel_summary} />
          <Dropdown trigger={["click"]} menu={{ items: extraActionsMenu() }}>
            <Tooltip title="More Actions" placement="bottomRight">
              <Button icon={<TbDots />} />
            </Tooltip>
          </Dropdown>
        </div>
      }
    >
      {openPaymentMethodModal && (
        <PaymentMethodModal
          appkey={appKey!}
          open={openPaymentMethodModal}
          onClose={() => setOpenPaymentMethodModal(false)}
        />
      )}

      <PageTitle
        title={
          fullApplication.data?.data?.application?.client_details?.name ??
          fullApplication.data?.application?.meta?.client_name ??
          "Application Item"
        }
        pageTitle={[
          { title: "Applications", link: "/dashboard/applications" },
          {
            title:
              fullApplication.data?.data?.application?.client_details?.name ??
              fullApplication.data?.application?.meta?.client_name ??
              "Application Item",
          },
        ]}
      />
      <SingleQueryWrapper
        query={fullApplication}
        renderData={(fullApplicationData) => {
          const getclearApplication = fullApplicationData.data.application;
          const adminApplication = fullApplicationData.application;
          // const isApplicationCompleted = getclearApplication.status.signatures || getclearApplication.status.onboarding;

          const isStrategySelected = Boolean(
            getclearApplication.strategy?.plan?.length || adminApplication.plan?.key?.length,
          );

          // const totalAmount = getclearApplication.loans?.reduce((prev, curr) => prev + (curr?.due_amount ?? 0), 0);
          // const totalWeeklyPayment = getclearApplication.loans?.reduce((prev, curr) => prev + (curr?.payments ?? 0), 0);
          const signedDocument = (getclearApplication?.external_links?.pandadoc ?? []).filter(
            (el: any) => el?.status === "document.completed",
          ).length;
          const isAllDetailsPrersent = validateRequiredFields({
            businessInfo: getclearApplication.business_info,
            clientDetails: getclearApplication.client_details,
            selectedBank: getclearApplication.selected_bank as SelectedBank,
          });

          // = adminApplication?.payment_table?.[adminApplication?.payment_table?.length - 1];

          return (
            <Splitter
              // className="grid grid-cols-[250px_auto]"
              style={{ height: "calc(100vh - 50px)" }}
            >
              <Splitter.Panel>
                <div style={{ minHeight: "calc(100vh - 50px)" }} className="p-6">
                  <div className=" flex justify-between items-center">
                    <div className="flex flex-col gap-2 items-start w-full">
                      <div className="flex justify-between items-center w-full mb-2">
                        <div className="flex items-center gap-2">
                          <Typography.Title
                            level={3}
                            className="!m-0 max-w-[500px]"
                            ellipsis={{
                              tooltip:
                                getclearApplication?.business_info?.company_name ||
                                getclearApplication?.client_details?.name ||
                                "-",
                            }}
                          >
                            {getclearApplication?.business_info?.company_name ||
                              getclearApplication?.client_details?.name ||
                              adminApplication.meta.client_name ||
                              "-"}
                          </Typography.Title>
                          <Typography.Text>
                            {adminApplication?.organisation?.code ? (
                              adminApplication?.isPriorApplication ? (
                                <div className="flex">
                                  <div className="inline-flex items-center gap-1 p-2 border border-solid border-gray-200 rounded-full h-8">
                                    <img
                                      src={adminApplication?.organisation?.meta?.favicon}
                                      className="size-5 rounded-full"
                                    />
                                    <Typography.Text className="text-xs font-semibold">
                                      {adminApplication?.organisation?.code.toUpperCase()}
                                    </Typography.Text>
                                  </div>
                                </div>
                              ) : (
                                <Dropdown
                                  trigger={["click"]}
                                  menu={{
                                    selectedKeys: [adminApplication.organisation._id || ""],
                                    items: getAllOrgData.map((profile) => ({
                                      key: profile.slug,
                                      disabled: adminApplication.organisation?._id === profile._id,
                                      className:
                                        adminApplication.organisation?._id === profile._id ? "bg-indigo-50" : "",
                                      style: {
                                        borderWidth: 2,
                                        borderStyle: "solid",
                                        borderColor:
                                          adminApplication.organisation?._id === profile.slug
                                            ? "#e0e7ff"
                                            : "transparent",
                                      },
                                      label: (
                                        <div className="flex items-center gap-2 w-full">
                                          <div className="flex items-center gap-3">
                                            <div
                                              role="button"
                                              onClick={() => {
                                                Modal.confirm({
                                                  width: 600,
                                                  title: "Change Organisation",
                                                  content:
                                                    getclearApplication.status.onboarding ||
                                                    getclearApplication.status.signatures ? (
                                                      <div>
                                                        <Typography.Paragraph>
                                                          You are changing organisation from{" "}
                                                          <Tag color="red">{adminApplication.organisation?.name}</Tag>{" "}
                                                          {"->"} <Tag color="blue">{profile?.name}</Tag>
                                                        </Typography.Paragraph>

                                                        <Alert
                                                          type="warning"
                                                          showIcon
                                                          className="mb-4"
                                                          message="Signed PandaDoc agreement will be reset"
                                                          description={
                                                            <div>
                                                              <Typography.Text>
                                                                This application already has a signed PandaDoc
                                                                agreement. Changing the organisation will permanently
                                                                delete the existing PandaDoc agreement and reset the
                                                                selected strategy.
                                                              </Typography.Text>

                                                              <div className="mt-2">
                                                                <Typography.Text strong>
                                                                  Please proceed with caution.
                                                                </Typography.Text>{" "}
                                                                The PandaDoc agreement will need to be completed again
                                                                for the new organisation.
                                                              </div>
                                                            </div>
                                                          }
                                                        />
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <Typography.Paragraph>
                                                          You are changing organisation from{" "}
                                                          <Tag color="red">{adminApplication.organisation?.name}</Tag>{" "}
                                                          {"->"} <Tag color="blue">{profile?.name}</Tag>
                                                        </Typography.Paragraph>

                                                        <Typography.Paragraph>
                                                          Any selected strategy will be reset upon proceeding.
                                                        </Typography.Paragraph>

                                                        <Typography.Paragraph>
                                                          If there are any incomplete PandaDoc agreement, changing the
                                                          organisation will permanently delete the existing agreement.
                                                        </Typography.Paragraph>
                                                      </div>
                                                    ),
                                                  okButtonProps: {
                                                    type: "primary",
                                                    loading: chnageOrgQuery.isPending,
                                                  },
                                                  onOk: () => {
                                                    chnageOrgQuery.mutate(
                                                      {
                                                        appkey: appKey,
                                                        org_id: profile._id,
                                                      },
                                                      {
                                                        onSuccess: () => {
                                                          message.success("Organisation changed succesfully.");

                                                          queryClient.invalidateQueries({
                                                            queryKey: ["application", appKey],
                                                          });

                                                          window.location.reload();
                                                        },
                                                      },
                                                    );
                                                  },
                                                });
                                              }}
                                              className="flex items-center gap-3 w-36"
                                            >
                                              <Avatar className="uppercase font-semibold" src={profile.meta?.favicon}>
                                                {profile.name.charAt(0).toUpperCase()}
                                              </Avatar>

                                              <div className="flex flex-col items-start">
                                                <Typography.Text type="secondary" className="text-xs">
                                                  {profile.name}
                                                </Typography.Text>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ),
                                    })),
                                  }}
                                >
                                  <div role="button" className="flex cursor-pointer">
                                    <div className="inline-flex items-center gap-1 p-2 border border-solid border-gray-200 rounded-full h-8">
                                      <img
                                        src={adminApplication?.organisation?.meta?.favicon}
                                        className="size-5 rounded-full"
                                      />
                                      <Typography.Text className="text-xs font-semibold">
                                        {adminApplication?.organisation?.code.toUpperCase()}
                                      </Typography.Text>
                                      <RiArrowDownSLine />
                                    </div>
                                  </div>
                                </Dropdown>
                              )
                            ) : null}
                          </Typography.Text>
                        </div>

                        <div className="flex items-center gap-2 flex-shrink-0 ml-4">
                          {adminApplication.isPriorApplication && (
                            <div className="relative overflow-hidden py-1 px-3 inline-flex items-center gap-1.5 rounded-full text-sm text-rose-800 bg-rose-50 border border-solid border-rose-300">
                              {/* Shine sweep */}
                              {/* <span className="pointer-events-none absolute inset-0 -translate-x-full animate-[shine_2.5s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" /> */}
                              <span
                                className="pointer-events-none absolute inset-0"
                                style={{
                                  transform: "translateX(-100%)",
                                  animation: "shine 2.5s ease-in-out infinite",
                                  background:
                                    "linear-gradient(to right, transparent, rgba(255,255,255,0.6), transparent)",
                                }}
                              />

                              <TbCircleCheck size={15} />
                              <span>{"Prior Application"}</span>
                            </div>
                          )}
                          {/* <div
                            className={`py-1 px-3 inline-flex items-center gap-1.5 rounded-full text-sm border ${
                              getclearApplication?.status?.onboarding === true
                                ? "text-green-800 bg-green-50 border border-solid border-green-300"
                                : "text-amber-800 bg-amber-50 border border-solid border-amber-300"
                            }`}
                          >
                            {getclearApplication?.status?.onboarding === true ? (
                              <TbCircleCheck size={15} />
                            ) : (
                              <TbAlertCircle size={15} />
                            )}
                            <span>
                              {getclearApplication?.status?.onboarding === true ? "Onboarded" : "Not onboarded"}
                            </span>
                          </div> */}
                          <StageSelect
                            size="large"
                            stages={applicationStages}
                            value={fullApplication.data?.application?.stages?.at(-1)}
                            loading={fullApplication.isLoading || stagesQuery.isLoading}
                            onChange={(stage) => {
                              if (!stage) return message.warning("Stage can not be unselected");
                              if (!appKey) return message.warning("AppKey not found");
                              updateApplicationStage.mutate(
                                { appKey, stage: stage._id },
                                {
                                  onSuccess() {
                                    message.success(`Stage changed to ${stage.label || stage.value}`);
                                    fullApplication.refetch();
                                  },
                                },
                              );
                            }}
                            // groupByLifecycle={false}
                          />

                          {getclearApplication?.external_links?.pandadoc &&
                            getclearApplication?.external_links?.pandadoc?.length > 0 && (
                              <div
                                className={`py-1 px-3 inline-flex items-center gap-1.5 rounded-full text-sm border ${signedDocument === getclearApplication?.external_links.pandadoc?.length ? "text-green-800 bg-green-50 border border-solid border-green-300" : `text-red-800 bg-red-50 border border-solid border-red-300`}`}
                              >
                                <TbFile size={15} />
                                {signedDocument} / {getclearApplication?.external_links.pandadoc?.length} agreements
                                signed
                              </div>
                            )}
                          {Boolean(fullApplicationData.application.strategy_source) && (
                            <Tooltip title={`Generated from ${fullApplicationData.application.strategy_source} app`}>
                              <div
                                className={`size-6 p-1 rounded-full text-white/80 flex items-center justify-center ${fullApplicationData.application.strategy_source === StrategySource.ADMIN_API ? "bg-purple-500" : "bg-emerald-500"}`}
                              >
                                {fullApplicationData.application.strategy_source === StrategySource.CUSTOMER_API ? (
                                  <TbDeviceMobile size={16} />
                                ) : (
                                  <TbDeviceDesktop size={16} />
                                )}
                              </div>
                            </Tooltip>
                          )}
                          <Popover
                            trigger="hover"
                            placement="bottom"
                            mouseEnterDelay={0.15}
                            styles={{
                              body: {
                                padding: 4,
                              },
                            }}
                            content={
                              <BusinessInfoComponent
                                businessInfo={{
                                  ...getclearApplication.business_info,
                                }}
                                clientDetails={{
                                  ...getclearApplication.client_details,
                                }}
                                openModal={() => setIsBusinessDetailsOpen(true)}
                                setBusinessInfo={(info) => setBusinessInfo(info)}
                                setClientDetails={(info) => setClientDetails(info)}
                                setBankDetails={() => {
                                  setBankDetails(getclearApplication.selected_bank as SelectedBank);
                                }}
                              />
                            }
                            destroyTooltipOnHide
                          >
                            <TbInfoCircle color="blue" size={18} />
                          </Popover>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 mb-4">
                        <div className="flex items-center gap-1">
                          <div className="inline-flex items-center gap-1.5 text-sm">
                            <TbUser className="text-gray-400" size={16} />
                            <Tooltip
                              title={getclearApplication?.client_details?.name || adminApplication.meta.client_name}
                            >
                              <Typography.Text className="inline-block max-w-[250px] overflow-hidden whitespace-nowrap text-ellipsis">
                                {getclearApplication?.client_details?.name || adminApplication.meta.client_name}
                              </Typography.Text>
                            </Tooltip>
                          </div>

                          {getclearApplication.application_type === ApplicationType.AFFILIATE ? (
                            <Tooltip
                              title={
                                <div>
                                  <div>
                                    <strong>Name:</strong> {fullApplication.data?.application.affiliate?.name ?? "-"}
                                  </div>
                                  <div>
                                    <strong>Email:</strong> {fullApplication.data?.application.affiliate?.email ?? "-"}
                                  </div>
                                </div>
                              }
                            >
                              <Tag className="ml-2 cursor-pointer flex items-center gap-1 w-fit" color="green">
                                AFFILIATE <InfoCircleOutlined />
                              </Tag>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                        <Divider type="vertical" />

                        {(getclearApplication?.client_details?.phone || adminApplication?.meta?.phone) && (
                          <div className={chipClass}>
                            <TbPhone className="text-gray-400" />
                            <span>
                              {phoneFormatter(
                                "1" + (getclearApplication?.client_details?.phone || adminApplication?.meta?.phone),
                              )}
                            </span>

                            <Tooltip title="Copy">
                              {isCopied && copyKey === "phone" ? (
                                <TbClipboardCheck
                                  key="copied-icon"
                                  className="stroke-green-500 cursor-pointer flex-shrink-0 ml-1"
                                />
                              ) : (
                                <TbCopy
                                  className="cursor-pointer flex-shrink-0 ml-1"
                                  color="#7f65f1"
                                  onClick={(e) => {
                                    setCopyKey("phone");
                                    setIsCopied(true);
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(
                                      phoneFormatter(
                                        "1" +
                                          (getclearApplication?.client_details?.phone || adminApplication?.meta?.phone),
                                      ),
                                    );
                                    setTimeout(() => {
                                      setIsCopied(false);
                                    }, 800);
                                  }}
                                />
                              )}
                            </Tooltip>
                          </div>
                        )}

                        {(getclearApplication?.business_info?.email || adminApplication?.meta?.email) && (
                          <div className={chipClass}>
                            <TbMail className="text-gray-400" />

                            <a
                              href={`mailto:${
                                getclearApplication?.business_info?.email || adminApplication?.meta?.email
                              }`}
                              onClick={(e) => e.stopPropagation()}
                              className="text-inherit no-underline"
                            >
                              {getclearApplication?.business_info?.email || adminApplication?.meta?.email}
                            </a>

                            {isCopied && copyKey === "email" ? (
                              <TbClipboardCheck
                                key="copied-icon"
                                className="stroke-green-500 cursor-pointer flex-shrink-0 ml-1"
                              />
                            ) : (
                              <Tooltip title="Copy">
                                <TbCopy
                                  className="cursor-pointer flex-shrink-0 ml-1"
                                  color="#7f65f1"
                                  onClick={(e) => {
                                    setCopyKey("email");
                                    setIsCopied(true);
                                    e.stopPropagation();

                                    navigator.clipboard.writeText(
                                      getclearApplication?.business_info?.email || adminApplication?.meta?.email || "-",
                                    );

                                    setTimeout(() => {
                                      setIsCopied(false);
                                    }, 800);
                                  }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        )}

                        {getclearApplication?.bank_fetch_via === BankFetchMethod.PLAID && (
                          <div className={chipClass}>
                            <div
                              className="inline-flex items-center justify-center"
                              style={{
                                background:
                                  getclearApplication?.plaid_config?.status === PlaidConnectionStatus.CONNECTED
                                    ? "#10B981"
                                    : "#EF4444",
                                width: 20,
                                height: 20,
                                borderRadius: 6,
                              }}
                            >
                              <PlaidIcon size={12} style={{ color: "#fff" }} />
                            </div>
                            <span className="ml-1">Plaid</span>
                          </div>
                        )}
                      </div>

                      <div className="p-3 border border-gray-200 rounded-xl w-full">
                        <div className="w-full overflow-x-auto">
                          {(() => {
                            const stages =
                              getclearApplication.application_type === ApplicationType.DROP
                                ? [
                                    "banks",
                                    "loans",
                                    "lawsuits",
                                    "strategy",
                                    "personal_info",
                                    "signatures",
                                    "onboarding",
                                  ]
                                : [
                                    "loans",
                                    "banks",
                                    "lawsuits",
                                    "strategy",
                                    "personal_info",
                                    "signatures",
                                    "onboarding",
                                  ];

                            const status = getclearApplication?.status ?? {};

                            return (
                              <div className="relative min-w-[720px] py-2">
                                <div className="relative z-10 flex items-start justify-between gap-1">
                                  {stages.map((stage, idx) => {
                                    const isNotStarted = stage === "";
                                    const isDone = stage && status[stage as keyof typeof status] === true;

                                    const color = isDone
                                      ? getLifeCycleStageColor(stage)
                                      : isNotStarted
                                        ? "#E5E7EB"
                                        : "#9CA3AF";

                                    return (
                                      <div key={stage || `s-${idx}`} className="flex flex-col items-center flex-1">
                                        <div
                                          className="w-full rounded-full transition-all duration-300"
                                          style={{
                                            height: 8,
                                            background: color,
                                            opacity: isDone ? 1 : isNotStarted ? 0.25 : 0.5,
                                          }}
                                        />

                                        <div
                                          className="mt-3 text-center text-[10px] font-semibold whitespace-normal break-words leading-tight"
                                          style={{
                                            maxWidth: 90,
                                            color: isDone ? color : "#9CA3AF",
                                          }}
                                        >
                                          {String(stage || "NOT STARTED")
                                            .split("_")
                                            .join(" ")
                                            .toUpperCase()}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* {getclearApplication && <BusinessInfo businessInfo={getclearApplication.business_info} />} */}

                  <div className="mt-4"></div>
                  <Divider className="!mb-0" />
                  <Tabs
                    defaultActiveKey="loans"
                    activeKey={activeKey}
                    onChange={(key) => {
                      setActiveKey(key as TabKeyType);
                      setSearchParams({ tab: key as TabKeyType });
                    }}
                    items={[
                      {
                        key: "loans",
                        label: "Loans & Lawsuits",
                        icon: <TbTax className="min-w-4" />,
                        children: (
                          <div className="flex flex-col gap-6">
                            {getclearApplication?.loans?.some(
                              (loan) =>
                                loan.funded_amount == null ||
                                loan.funded_date == null ||
                                loan.payback_amount == null ||
                                loan.due_amount == null,
                            ) && (
                              <Alert
                                type="error"
                                // showIcon
                                closable
                                description="Some required loan information is missing. These fields are needed to provide insights and process the loan for further steps in the application."
                                style={{ padding: "8px 12px" }}
                              />
                            )}
                            <div className="border border-solid border-gray-200 rounded-lg">
                              <div className="flex items-center justify-between mx-3 my-3">
                                <Typography.Title level={5} className="">
                                  Loans Details
                                </Typography.Title>
                                {
                                  <div className="flex items-center gap-1">
                                    <Button
                                      loading={loanPipeline.isLoading}
                                      disabled={!loanPipeline.data?._id || !loanMapping.data?.length}
                                      icon={<TbColumns3 />}
                                      size="small"
                                      variant="outlined"
                                      color="cyan"
                                      className="disabled:opacity-70"
                                      onClick={() => {
                                        const boardId = loanPipeline.data?._id;
                                        const scopeId = fullApplicationData.application._id;
                                        if (boardId && scopeId) {
                                          navigate(`/dashboard/operations/pipelines/${boardId}?scopeId=${scopeId}`);
                                        }
                                      }}
                                    >
                                      View Pipeline
                                    </Button>

                                    <Button
                                      loading={syncBalance.isPending}
                                      onClick={() => {
                                        syncBalance.mutate(
                                          {
                                            appkey: appKey as string,
                                          },
                                          {
                                            onSuccess: () => {
                                              message.success("Balance synced successfully.");
                                              queryClient.invalidateQueries({
                                                queryKey: ["application", appKey],
                                              });
                                            },
                                          },
                                        );
                                      }}
                                      icon={<TbRefresh />}
                                      size="small"
                                      variant="outlined"
                                      color="green"
                                    >
                                      Sync Balance
                                    </Button>

                                    <Button
                                      onClick={() => {
                                        setSelectedLoan(undefined);
                                        setOpenCreditorModal(true);
                                      }}
                                      icon={<TbTax />}
                                      size="small"
                                      variant="outlined"
                                      color="purple"
                                    >
                                      Add New Loan
                                    </Button>
                                    {/* <Button
                                      onClick={() => {
                                        setIsLoanUploadModalOpen(true);
                                        setUploadType("loan");
                                      }}
                                      icon={<TbUpload />}
                                      size="small"
                                      variant="outlined"
                                      color="purple"
                                    >
                                      Upload New Loan
                                    </Button> */}
                                  </div>
                                }
                              </div>
                              <Table
                                rowKey={"_id"}
                                scroll={{
                                  y: 400,
                                  x: 1500,
                                }}
                                virtual
                                onRow={(record) => ({
                                  onClick: (e) => {
                                    if (isOcrProcessing(record)) {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }
                                  },
                                })}
                                rowClassName={(record) =>
                                  isOcrProcessing(record) ? "opacity-40 pointer-events-none" : ""
                                }
                                columns={[
                                  {
                                    key: "creditor_name",
                                    dataIndex: "creditor_name",
                                    title: "Creditor Name",
                                    width: 200,
                                    render: (value: string, record) => {
                                      const attachment = record.attachments?.[0];
                                      const matchType = record?.creditor_match;

                                      const tagConfig =
                                        matchType === CreditorMatchSync.MATCHED
                                          ? { label: "M", color: "green", tooltip: "Matched" }
                                          : matchType === CreditorMatchSync.PROBABLE
                                            ? { label: "P", color: "yellow", tooltip: "Probable match" }
                                            : matchType === CreditorMatchSync.DRAFT
                                              ? { label: "D", color: "red", tooltip: "Draft" }
                                              : { label: "N", color: "default", tooltip: "Not linked" };

                                      const isProcessing = isOcrProcessing(record);
                                      const isFailed = isOcrFailed(record);

                                      return (
                                        <div className="flex justify-between items-center gap-2">
                                          <Space>
                                            {isProcessing && (
                                              <Tooltip title="OCR processing in progress... Auto-refreshing every 5 seconds">
                                                <TbLoader2
                                                  className="h-4 w-4 animate-spin text-blue-500"
                                                  aria-label="OCR processing"
                                                />
                                              </Tooltip>
                                            )}
                                            {firstOutbound.isPending &&
                                              firstOutbound.variables.body.loan_id === record._id && (
                                                <Tooltip title="Generating smart negotiation context">
                                                  <TbLoader2
                                                    className="h-4 w-4 animate-spin text-purple-500"
                                                    aria-label="Negotiation context"
                                                  />
                                                </Tooltip>
                                              )}
                                            {/* {isFailed && (
                                            <Tooltip title="OCR Failed">
                                              <TbAlertCircle
                                                className="h-4 w-4 animate-spin text-red-500"
                                                aria-label="OCR Failed"
                                              />
                                            </Tooltip>
                                          )} */}
                                            <div className="flex flex-col items-start">
                                              {attachment ? (
                                                <ViewFileLink
                                                  fileId={attachment._id}
                                                  appKey={getclearApplication.app_key}
                                                >
                                                  {value}
                                                </ViewFileLink>
                                              ) : (
                                                <span>{value}</span>
                                              )}
                                              {isFailed && (
                                                <div className="flex flex-col items-start">
                                                  <Typography.Text className="!text-xs" type="danger">
                                                    OCR Failed.
                                                  </Typography.Text>

                                                  {record.ocr_remark && (
                                                    <Popover
                                                      trigger="click"
                                                      placement="top"
                                                      content={
                                                        <div className="max-w-sm">
                                                          {record.confidence_score != null && (
                                                            <div className="mb-2 font-semibold">
                                                              Confidence: {record.confidence_score}%
                                                            </div>
                                                          )}
                                                          <Typography.Text className="!text-xs">
                                                            {record.ocr_remark}
                                                          </Typography.Text>
                                                        </div>
                                                      }
                                                    >
                                                      <Typography.Link
                                                        className="!p-0 !text-[11px]"
                                                        onClick={(e) => e.stopPropagation()}
                                                      >
                                                        Click here to learn why.
                                                      </Typography.Link>
                                                    </Popover>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          </Space>
                                          <div className="flex gap-2 items-center">
                                            <Tooltip title={tagConfig.tooltip}>
                                              <Tag
                                                className="!m-0 w-fit px-2 py-0.5 text-xs font-semibold"
                                                color={tagConfig.color}
                                                onClick={() => navigate(`/dashboard/creditors?search=${value}`)}
                                              >
                                                {tagConfig.label}
                                              </Tag>
                                            </Tooltip>
                                            {!isProcessing && record.due_amount === undefined && (
                                              <Tooltip title="Balance amount should be provided. Please edit loan details.">
                                                <span className="inline-flex items-center text-gray-400 hover:text-gray-600">
                                                  <TbInfoCircle color="red" className="h-4 w-4" />
                                                </span>
                                              </Tooltip>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    key: "funded_amount",
                                    dataIndex: "funded_amount",
                                    title: "Funded Amount",
                                    align: "end",
                                    render: (val, record) => {
                                      const isEditing =
                                        editingLoanId === record._id && editingField === "funded_amount";
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          {isEditing ? (
                                            <InputNumber
                                              controls={false}
                                              prefix="$"
                                              value={editValue ?? val}
                                              onChange={(value) => setEditValue(value)}
                                              style={{ width: "140px" }}
                                              formatter={(value) => {
                                                const [start, end] = `${value}`.split(".") || [];
                                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `${end ? `${v}.${end}` : `${v}`}`;
                                              }}
                                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                                            />
                                          ) : (
                                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                                          )}
                                          {!isEditing ? (
                                            <TbEdit
                                              onClick={() => handleStartEdit(record._id, "funded_amount", val)}
                                              style={{ cursor: "pointer", flexShrink: 0 }}
                                            />
                                          ) : editValue !== val ? (
                                            <TbCheck
                                              onClick={() => handleSaveEdit(record)}
                                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                                            />
                                          ) : null}
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    key: "payback_amount",
                                    dataIndex: "payback_amount",
                                    title: "Payback Amount",
                                    align: "end",
                                    render: (val, record) => {
                                      const isEditing =
                                        editingLoanId === record._id && editingField === "payback_amount";
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          {isEditing ? (
                                            <InputNumber
                                              controls={false}
                                              prefix="$"
                                              value={editValue ?? val}
                                              onChange={(value) => setEditValue(value)}
                                              style={{ width: "140px" }}
                                              formatter={(value) => {
                                                const [start, end] = `${value}`.split(".") || [];
                                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `${end ? `${v}.${end}` : `${v}`}`;
                                              }}
                                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                                            />
                                          ) : (
                                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                                          )}
                                          {!isEditing ? (
                                            <TbEdit
                                              onClick={() => handleStartEdit(record._id, "payback_amount", val)}
                                              style={{ cursor: "pointer", flexShrink: 0 }}
                                            />
                                          ) : editValue !== val ? (
                                            <TbCheck
                                              onClick={() => handleSaveEdit(record)}
                                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                                            />
                                          ) : null}
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    key: "due_amount",
                                    dataIndex: "due_amount",
                                    title: "Balance Amount",
                                    align: "end",
                                    render: (val, record) => {
                                      const isEditing = editingLoanId === record._id && editingField === "due_amount";
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          {isEditing ? (
                                            <InputNumber
                                              controls={false}
                                              prefix="$"
                                              value={editValue ?? val}
                                              onChange={(value) => setEditValue(value)}
                                              style={{ width: "140px" }}
                                              formatter={(value) => {
                                                const [start, end] = `${value}`.split(".") || [];
                                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `${end ? `${v}.${end}` : `${v}`}`;
                                              }}
                                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                                            />
                                          ) : (
                                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                                          )}
                                          {!isEditing ? (
                                            <TbEdit
                                              onClick={() => handleStartEdit(record._id, "due_amount", val)}
                                              style={{ cursor: "pointer", flexShrink: 0 }}
                                            />
                                          ) : editValue !== val ? (
                                            <TbCheck
                                              onClick={() => handleSaveEdit(record)}
                                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                                            />
                                          ) : null}
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    key: "payments",
                                    dataIndex: "payments",
                                    title: "Installation Payment",
                                    align: "end",
                                    render: (val, record) => (
                                      <TextNumeric>
                                        {record?.payments ? formatMoney(record?.payments) : "-"}
                                      </TextNumeric>
                                    ),
                                  },
                                  {
                                    key: "frequency",
                                    dataIndex: "frequency",
                                    title: "Frequency",
                                    align: "center",
                                    width: 120,
                                    render: (val, record) => {
                                      return (
                                        <div className="flex justify-end items-center gap-1">
                                          <Typography.Text>{record?.frequency?.toUpperCase()}</Typography.Text>
                                          {editUpstreamLoan.isPending &&
                                          editUpstreamLoan.variables.loan._id === record._id ? (
                                            <TbLoader2 size={16} className="animate-spin" />
                                          ) : (
                                            <Dropdown
                                              menu={{
                                                selectable: true,
                                                selectedKeys: record.frequency ? [record.frequency] : [],

                                                items: Object.values(FREQUENCY_TYPES).map((val, i) => {
                                                  return {
                                                    key: val,

                                                    label: toTitleCase(val),
                                                    onClick: () =>
                                                      handleLoanFrequencyChange({
                                                        prevFrequency: record.frequency as FREQUENCY_TYPES,
                                                        newFrequency: val,
                                                        record: record,
                                                      }),
                                                  };
                                                }),
                                              }}
                                            >
                                              <Button type="text" size="small" icon={<TbDotsVertical />} />
                                            </Dropdown>
                                          )}
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    key: "funded_date",
                                    dataIndex: "funded_date",
                                    title: "Funded Date",
                                    align: "center",
                                    render: (val, record) => (
                                      <TextNumeric>
                                        {record?.funded_date ? formatDate(record?.funded_date) : "-"}
                                      </TextNumeric>
                                    ),
                                  },
                                  {
                                    key: "receivables",
                                    dataIndex: "receivables",
                                    title: "Receivables",
                                    width: 100,
                                    render: (val, record) => {
                                      const isEditing = editingLoanId === record._id && editingField === "receivables";
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          {isEditing ? (
                                            <InputNumber
                                              controls={false}
                                              suffix="%"
                                              value={editValue ?? val}
                                              onChange={(value) => setEditValue(value)}
                                              style={{ width: "100px" }}
                                              min={0}
                                              max={100}
                                              formatter={(value) => {
                                                const [start, end] = `${value}`.split(".") || [];
                                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `${end ? `${v}.${end}` : `${v}`}`;
                                              }}
                                              parser={(value) => value?.replace(/%\s?|(,*)/g, "") as unknown as number}
                                            />
                                          ) : record?.receivables ? (
                                            <TextNumeric>{`${record?.receivables}%`}</TextNumeric>
                                          ) : (
                                            <span>-</span>
                                          )}
                                          {!isEditing ? (
                                            <TbEdit
                                              onClick={() => handleStartEdit(record._id, "receivables", val || 0)}
                                              style={{ cursor: "pointer", flexShrink: 0 }}
                                            />
                                          ) : editValue !== val ? (
                                            <TbCheck
                                              onClick={() => handleSaveEdit(record)}
                                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                                            />
                                          ) : null}
                                          <PaymentComparator
                                            {...record}
                                            onViewAnalysis={(record) => setAnalyzeLoan(record)}
                                          />
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    title: "Status",
                                    key: "status",
                                    align: "left",
                                    render: (_, record) => {
                                      const mappedLoanData = getMappedLoanData(record._id);

                                      return (
                                        <StageSelect
                                          size="small"
                                          stages={loanStages}
                                          loading={stagesQuery.isPending}
                                          value={mappedLoanData?.stages?.at(-1)}
                                          disabled={
                                            updateLoanStage.isPending &&
                                            updateLoanStage.variables?.loanId === record._id
                                          }
                                          onChange={(stage) => {
                                            if (!appKey) return message.warning("AppKey not found");
                                            if (!stage?._id) return;

                                            updateLoanStage.mutate(
                                              { appKey, loanId: record._id, stage: stage._id },
                                              {
                                                onSettled: () => loanMapping.refetch(),
                                                onSuccess: () => message.success(`Loan moved to ${stage.label}`),
                                              },
                                            );
                                          }}
                                        />
                                      );
                                    },
                                  },
                                  {
                                    title: "Actions",
                                    key: "actions",
                                    fixed: "right",
                                    align: "right",
                                    width: 75,
                                    className: "border-0 border-l border-solid border-gray-200",
                                    render: (_, record) => {
                                      const menuItems: ItemType[] = [
                                        {
                                          key: "link-creditor",
                                          icon: <TbPlugConnected />,
                                          label: "Link Creditor",
                                          onClick: () => {
                                            setSelectedLoan(record);
                                            setOpenLinkCreditor(true);
                                          },
                                        },
                                        {
                                          key: "update-creditor",
                                          icon: <TbRefresh />,
                                          label: "Update Loan Details",
                                          onClick: () => {
                                            setSelectedLoan(record);
                                            setOpenCreditorModal(true);
                                          },
                                        },
                                        {
                                          key: "upload-lawsuits",
                                          icon: <TbUpload />,
                                          label: "Upload Lawsuits",
                                          onClick: () => {
                                            setSelectedLoan(record);
                                            setIsLawSuitsUploadModalOpen(true);
                                          },
                                        },
                                        {
                                          key: "negotiation-context",
                                          disabled: firstOutbound.isPending,
                                          className: "!p-0 !overflow-hidden",
                                          label: (
                                            <ShinyMenuItem
                                              className="flex w-full items-center gap-2 !px-3 !py-[5px]"
                                              icon={
                                                firstOutbound.isPending &&
                                                firstOutbound.variables.body.loan_id === record._id ? (
                                                  <TbLoader2 className="animate-spin" />
                                                ) : (
                                                  <TbSparkles />
                                                )
                                              }
                                              label="Negotiation Suggestions"
                                            />
                                          ),
                                          onClick: () => {
                                            handleSendFirstOutBound({ loanId: record._id });
                                          },
                                        },
                                        {
                                          key: "emails",
                                          icon: <TbInbox />,
                                          label: "View Emails",
                                          onClick() {
                                            navigate(
                                              `/dashboard/application/${appKey}/email?selectedLoan=${record._id}`,
                                            );
                                          },
                                        },
                                        {
                                          key: "loan-payment-timeline",
                                          // disabled: firstOutbound.isPending,
                                          icon: <TbClock />,
                                          label: "Payment History",
                                          onClick: () => {
                                            setSelectedLoan(record);
                                            setIsLoanPaymentTimelineDrawerOpen(true);
                                          },
                                        },
                                        {
                                          key: "navigate-creditor-logs",
                                          icon: <TbTransactionDollar />,
                                          label: "View Creditor Txn. Logs",
                                          onClick: () => {
                                            if (record.creditor_id) {
                                              window.open(
                                                `/dashboard/transaction-logs?creditor_id=${record.creditor_id}&wallet_type=${WalletTypes.CREDITOR}`,
                                              );
                                            } else {
                                              message.error("Creditor ID not found. Link the creditor first.");
                                            }
                                          },
                                        },
                                        record.expected_payment_breakdown
                                          ? {
                                              key: "payment-reconciliation",
                                              icon: <TbAnalyze />,
                                              label: "Payment Reconciliation",
                                              onClick: () => setAnalyzeLoan(record),
                                            }
                                          : null,
                                        {
                                          key: "delete-lawsuits",
                                          icon: <TbTrash />,
                                          label: "Delete Loan",
                                          onClick: () => {
                                            //
                                            Modal.confirm({
                                              centered: true,
                                              title: `Are you sure you want to delete ${record.creditor_name}?`,
                                              content: (
                                                <div className="flex flex-col items-start">
                                                  {" "}
                                                  <Typography.Text> This action cannot be undone.</Typography.Text>
                                                  {adminApplication.plan?.key && (
                                                    <Alert
                                                      icon={<TbAlertCircle size={20} />}
                                                      className="mt-4"
                                                      type="warning"
                                                      message="Deleting a loan will reset your current selected strategy. Please re-select your preferred strategy after deleting the loan."
                                                    />
                                                  )}
                                                </div>
                                              ),
                                              okText: "Yes, Delete",
                                              okType: "danger",
                                              cancelText: "No, Keep",
                                              onOk: () => {
                                                deleteLoan.mutate(
                                                  { appkey: appKey as string, loan_id: record._id },
                                                  {
                                                    onSuccess: async () => {
                                                      message.success("Loan deleted sucessfully.");

                                                      await queryClient.invalidateQueries({
                                                        queryKey: ["application", appKey],
                                                        refetchType: "active",
                                                      });
                                                    },
                                                  },
                                                );
                                              },
                                            });
                                          },
                                          danger: true,
                                        },
                                      ];

                                      return (
                                        <Dropdown
                                          trigger={["click"]}
                                          menu={{
                                            items: menuItems,
                                          }}
                                        >
                                          <Button icon={<TbDotsVertical />} />
                                        </Dropdown>
                                      );
                                    },
                                  },
                                ]}
                                dataSource={getclearApplication?.loans}
                                pagination={false}
                                size="small"
                                summary={(loans) => {
                                  return (
                                    <Table.Summary fixed={"bottom"}>
                                      <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} className="bg-gray-100 font-bold text-gray-800">
                                          Total
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={1}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        >
                                          {loans
                                            ? formatMoney(
                                                loans?.reduce((prev, curr) => prev + (curr?.funded_amount ?? 0), 0),
                                              )
                                            : "-"}
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={2}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        >
                                          {loans
                                            ? formatMoney(
                                                loans?.reduce((prev, curr) => prev + (curr?.payback_amount ?? 0), 0),
                                              )
                                            : "-"}
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={3}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        >
                                          {loans
                                            ? formatMoney(
                                                loans?.reduce((prev, curr) => prev + (curr?.due_amount ?? 0), 0),
                                              )
                                            : "-"}
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={4}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        >
                                          {loans
                                            ? `${formatMoney(
                                                loans?.reduce(
                                                  (prev, curr) =>
                                                    prev +
                                                    (curr?.payments ?? 0) *
                                                      (5 /
                                                        LoanFrequencyMultiplier[
                                                          curr.frequency ?? FREQUENCY_TYPES.WEEKLY
                                                        ]),
                                                  0,
                                                ),
                                              )}/week`
                                            : "-"}
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={5}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        ></Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={6}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        ></Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={6}
                                          align="left"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        >
                                          {loans?.reduce((prev, curr) => prev + (curr.receivables ?? 0), 0)?.toFixed(2)}
                                          %
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell
                                          index={6}
                                          align="right"
                                          className="bg-gray-100 font-bold text-gray-800"
                                        ></Table.Summary.Cell>
                                      </Table.Summary.Row>
                                    </Table.Summary>
                                  );
                                }}
                              />
                            </div>
                            {getclearApplication.loans.length > 0 &&
                              getclearApplication?.lawsuits &&
                              getclearApplication?.lawsuits?.length === 0 && (
                                <Alert
                                  message={
                                    "Use the three dot button in loan table to upload lawsuits for that particular loan"
                                  }
                                  type="info"
                                  showIcon
                                />
                              )}
                            {getclearApplication?.lawsuits && getclearApplication?.lawsuits?.length ? (
                              <div className="border border-solid border-gray-200 rounded-lg">
                                <div className="flex items-center mb-3">
                                  <Typography.Title level={5} className="mx-3 my-3">
                                    Lawsuit Details
                                  </Typography.Title>
                                  {/* <span className="text-sm font-medium py-1 px-2 rounded-2xl bg-gray-100">
                                    {getclearApplication?.lawsuits?.length}
                                  </span> */}
                                  <Badge
                                    color={"purple"}
                                    size="default"
                                    count={getclearApplication?.lawsuits?.length}
                                  />
                                </div>
                                <div className="grid grid-cols-12 gap-y-2 mx-3 mb-3">
                                  {getclearApplication?.lawsuits?.map((lawsuit, i) => {
                                    const loan = getclearApplication?.loans?.find((el) => el._id === lawsuit?.loan);
                                    // console.log({ loan });
                                    return (
                                      <Fragment key={lawsuit._id}>
                                        <div className="col-span-8">
                                          {!loan ? (
                                            <Typography.Text>Loan was deleted</Typography.Text>
                                          ) : (
                                            <Typography.Text>{`${i + 1}. ${loan?.creditor_name} (${formatMoney(loan?.funded_amount)})`}</Typography.Text>
                                          )}
                                        </div>
                                        <div className="col-span-4 justify-self-end">
                                          {lawsuit?.attachments?.length > 0 ? (
                                            <ViewFileLawsuits
                                              attachments={lawsuit?.attachments}
                                              appKey={getclearApplication?.app_key}
                                              deletingFileId={deletingLawsuitFileId}
                                              onDelete={(fileId) => handleLawsuitDeleteFile(fileId, lawsuit._id)}
                                            />
                                          ) : null}
                                        </div>
                                      </Fragment>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ),
                      },
                      {
                        key: "banks",
                        label: "Banks",
                        icon: <TbBuildingBank className="min-w-4" />,
                        children: (
                          <div className="flex flex-col gap-6">
                            <MissingBankPeriods appkey={appKey} />
                            {fullApplicationData.data.application.bank_fetch_via === BankFetchMethod.PLAID &&
                            fullApplication.data?.data.application.plaid_config?.status ===
                              PlaidConnectionStatus.PENDING ? (
                              <Alert
                                type="info"
                                showIcon
                                closable
                                message={
                                  <span>
                                    We noticed that this application started Plaid linking process. Please make sure to{" "}
                                    <strong>
                                      complete all the way through the final step in Plaid, where you will be told that
                                      it is safe to close the browser.
                                    </strong>
                                  </span>
                                }
                              />
                            ) : null}
                            {fullApplicationData.data.application.bank_fetch_via === BankFetchMethod.PLAID &&
                            fullApplication.data?.data.application.plaid_config?.status ===
                              PlaidConnectionStatus.DISCONNECTED ? (
                              <Alert
                                type="warning"
                                showIcon
                                closable
                                message={
                                  <span>
                                    We noticed that this application has a revoked Plaid link. An automatic relink email
                                    was sent at the time of revoke, or you may relink again if the email expired. Please
                                    make sure to{" "}
                                    <strong>
                                      complete all the way through the final step in Plaid, where you will be told that
                                      it is safe to close the browser.
                                    </strong>
                                  </span>
                                }
                              />
                            ) : null}
                            <div className="border border-solid border-gray-200 rounded-lg">
                              <div className="flex items-center justify-between mx-3 my-3">
                                <Typography.Title level={5} className="">
                                  Bank Details
                                </Typography.Title>
                                <div className="flex items-center gap-1">
                                  {/* <Button
                                    onClick={() => {
                                      setSelectedBank(undefined);
                                      setOpenEditBank(true);
                                    }}
                                    icon={<TbBuildingBank />}
                                    size="small"
                                    variant="outlined"
                                    color="purple"
                                  >
                                    Add Bank Details
                                  </Button> */}
                                  <div className="flex items-center gap-3">
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      color="magenta"
                                      // type="primary"
                                      icon={<TbFiles />}
                                      disabled={deleteBankFiles.isPending}
                                      onClick={() =>
                                        (window.location.href = `/dashboard/application/bank-statements/${appKey}`)
                                      }
                                    >
                                      Review Bank Statements
                                    </Button>
                                    {fullApplicationData.data.application.bank_fetch_via === BankFetchMethod.PLAID && (
                                      <Button
                                        onClick={() => {
                                          relinkPlaid.mutate(
                                            { appkey: appKey! },
                                            {
                                              onSuccess: () => {
                                                message.success("Relink mail has been sent to client.");
                                              },
                                            },
                                          );
                                        }}
                                        loading={relinkPlaid.isPending}
                                        disabled={relinkPlaid.isPending || deleteBankFiles.isPending}
                                        icon={<TbRestore />}
                                        size="small"
                                        variant="outlined"
                                        color="green"
                                      >
                                        Relink Plaid
                                      </Button>
                                    )}
                                    {fullApplicationData.data.application.bank_fetch_via !== BankFetchMethod.PLAID && (
                                      <Button
                                        onClick={() => {
                                          setIsLoanUploadModalOpen(true);
                                          setUploadType("bank");
                                        }}
                                        icon={<TbUpload />}
                                        size="small"
                                        variant="outlined"
                                        color="purple"
                                        disabled={deleteBankFiles.isPending}
                                      >
                                        Upload Bank Docs
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <Table
                                rowKey={"_id"}
                                // loading={application.isFetching}
                                columns={[
                                  {
                                    key: "name",
                                    dataIndex: "name",
                                    title: "Bank Name",
                                  },
                                  {
                                    key: "account_number",
                                    dataIndex: "account_number",
                                    title: "Account Number",
                                  },
                                  {
                                    key: "current_balance",
                                    dataIndex: "current_balance",
                                    title: "Current Balance",
                                    render: (val) => formatMoney(val),
                                  },
                                  {
                                    key: "Action",
                                    dataIndex: "Action",
                                    title: "Action",
                                    align: "end",
                                    render: (_, record) => {
                                      const menuItems: ItemType[] = [
                                        {
                                          key: "update-creditor",
                                          icon: <TbRefresh />,
                                          label: "Update Bank Details",
                                          onClick: () => {
                                            setSelectedBank(record);
                                            setOpenEditBank(true);
                                          },
                                        },
                                        // {
                                        //   key: "edit-loan-details",
                                        //   icon: <TbEdit />,
                                        //   label: "Edit Loan Details",
                                        //   onClick: () => {},
                                        // },
                                      ];

                                      return (
                                        <div className="">
                                          <ViewFileBanks
                                            attachments={record?.attachments}
                                            appKey={getclearApplication.app_key}
                                          />
                                          <Dropdown
                                            className="ml-4"
                                            trigger={["click"]}
                                            menu={{
                                              items: menuItems,
                                            }}
                                          >
                                            <Button icon={<TbDotsVertical />} />
                                          </Dropdown>
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                                dataSource={getclearApplication.banks}
                                pagination={false}
                                size="small"
                              />
                            </div>
                            {getclearApplication?.statement_files &&
                            getclearApplication?.statement_files?.length > 0 ? (
                              <div className="border border-solid border-gray-200 rounded-lg">
                                <div className="flex items-center justify-between mb-3 px-1">
                                  <div className="flex items-center gap-2">
                                    <Typography.Title level={5} className="mx-3 my-3">
                                      All Provided Bank Statements
                                    </Typography.Title>
                                    <span className="text-sm font-medium py-0.5 px-2 rounded-2xl bg-gray-100">
                                      {getclearApplication?.statement_files?.length}
                                    </span>
                                    {deleteBankFiles.isPending && (
                                      <span className="flex items-center gap-1 text-sm text-gray-500">
                                        <LoadingOutlined /> Deleting, please wait...
                                      </span>
                                    )}
                                  </div>

                                  <div className="flex items-center gap-2">
                                    {selectedBankFileIds.length > 0 && (
                                      <Popconfirm
                                        title={`Delete ${selectedBankFileIds.length} file(s)?`}
                                        onConfirm={() => handleBankFilesDelete(selectedBankFileIds)}
                                        okButtonProps={{ loading: deleteBankFiles.isPending }}
                                      >
                                        <Button
                                          size="small"
                                          danger
                                          icon={<TbTrash />}
                                          loading={deleteBankFiles.isPending}
                                          disabled={deleteBankFiles.isPending}
                                        >
                                          Delete Selected ({selectedBankFileIds.length})
                                        </Button>
                                      </Popconfirm>
                                    )}
                                    {/* <Button
                                      size="small"
                                      type="primary"
                                      disabled={deleteBankFiles.isPending}
                                      onClick={() =>
                                        (window.location.href = `/dashboard/application/bank-statements/${appKey}`)
                                      }
                                    >
                                      View Bank Statements Data
                                    </Button> */}
                                  </div>
                                </div>
                                <div className="grid grid-cols-12 gap-y-2 max-h-[400px] overflow-y-auto px-3 mb-3">
                                  {getclearApplication?.statement_files?.map((file) => {
                                    const isEditing = editingBankFileId === file._id;
                                    const isSaving = renameBankFiles.isPending && isEditing;
                                    const isChecked = selectedBankFileIds.includes(file._id);
                                    const isBusy = deleteBankFiles.isPending;

                                    return (
                                      <Fragment key={file._id}>
                                        <div className="col-span-8 flex items-center gap-2">
                                          <Checkbox
                                            checked={isChecked}
                                            disabled={isEditing || isBusy}
                                            onChange={(e) => {
                                              setSelectedBankFileIds((prev) =>
                                                e.target.checked
                                                  ? [...prev, file._id]
                                                  : prev.filter((id) => id !== file._id),
                                              );
                                            }}
                                          />
                                          {isEditing ? (
                                            <Input
                                              size="small"
                                              autoFocus
                                              disabled={isSaving}
                                              value={
                                                bankAliasDraft[file._id] ?? file?.alias ?? file?.original_file_name
                                              }
                                              onChange={(e) =>
                                                setbankAliasDraft((prev) => ({ ...prev, [file._id]: e.target.value }))
                                              }
                                              onPressEnter={() => handleBankSaveAlias(file._id)}
                                            />
                                          ) : (
                                            <>
                                              {file?.alias && file.alias !== file.original_file_name ? (
                                                <Tooltip title={`Original file name -> ${file?.original_file_name}`}>
                                                  <Typography.Text>{file.alias}</Typography.Text>
                                                </Tooltip>
                                              ) : (
                                                <Typography.Text>{file?.original_file_name}</Typography.Text>
                                              )}
                                              <Button
                                                size="small"
                                                icon={<EditOutlined />}
                                                disabled={isBusy}
                                                onClick={() => {
                                                  setEditingBankFileId(file._id);
                                                  setbankAliasDraft((prev) => ({
                                                    ...prev,
                                                    [file._id]: file?.alias ?? file?.original_file_name,
                                                  }));
                                                }}
                                              />
                                            </>
                                          )}
                                        </div>
                                        <div className="col-span-4 flex justify-end gap-2">
                                          {isEditing ? (
                                            <>
                                              <Button
                                                size="small"
                                                type="primary"
                                                loading={isSaving}
                                                disabled={isSaving}
                                                onClick={() => handleBankSaveAlias(file._id)}
                                              >
                                                Save
                                              </Button>
                                              <Button
                                                size="small"
                                                disabled={isSaving}
                                                onClick={() => setEditingBankFileId(null)}
                                              >
                                                Cancel
                                              </Button>
                                            </>
                                          ) : (
                                            <>
                                              <Popconfirm
                                                title="Delete this file?"
                                                onConfirm={() => handleBankFilesDelete([file._id])}
                                              >
                                                <Button size="small" danger icon={<TbTrash />} disabled={isBusy} />
                                              </Popconfirm>
                                              <ViewFileBtn fileId={file?._id} appKey={getclearApplication?.app_key} />
                                            </>
                                          )}
                                        </div>
                                      </Fragment>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ),
                      },
                      {
                        key: "ledger",
                        label: "Payment Ledger",
                        icon: <TbTable className="min-w-4" />,
                        children: isStrategySelected ? (
                          <div className="border border-solid border-gray-200 rounded-lg">
                            <div className="flex items-center gap-2 mb-1 justify-between m-3">
                              <div className="inline-flex gap-2">
                                <Typography.Title level={5} className="!mx-0">
                                  Payment Ledger
                                </Typography.Title>
                                <Tag className="h-fit">
                                  {hasEnded ? "" : "> "}
                                  {isMonthly
                                    ? Math.floor((latestPaymentTable?.weeks ?? 0) / 4)
                                    : latestPaymentTable.weeks}
                                  +1 {isMonthly ? "months" : "weeks"}
                                </Tag>
                              </div>
                              {latestPaymentTable ? (
                                <div className="inline-flex gap-2 items-center">
                                  <span className="text-sm font-medium py-0.5 px-2 rounded-2xl bg-gray-100">
                                    v{latestPaymentTable?.version}
                                  </span>
                                  <Typography.Text type="secondary" className="text-xs">
                                    Last updated at {formatDateTime(latestPaymentTable?.created)}
                                  </Typography.Text>
                                </div>
                              ) : null}
                            </div>
                            <div className="flex items-center justify-between gap-3 text-xs text-gray-500 px-3 pb-2">
                              <div>
                                <span>
                                  <span style={{ textDecoration: "line-through", color: "#8c8c8c" }}>$X</span>{" "}
                                  <strong>$Y</strong>
                                </span>
                                <span>
                                  where X is the total amount & Y is the amount left to pay (partial payments)
                                </span>
                              </div>
                              <div className="flex items-center gap-2">
                                <Button
                                  variant="solid"
                                  icon={<TbEdit />}
                                  color="magenta"
                                  onClick={() => setOpenEditableLedgerModal(true)}
                                  size="small"
                                >
                                  Edit
                                </Button>
                                {fullApplication.data?.application.autopay_status === AutopayStatus.ACTIVE ? (
                                  <>
                                    <Tag color="red">
                                      <Space size={4}>
                                        PAYMENT AUTOMATION ACTIVE
                                        <Tooltip title="View and control payment automation">
                                          <InfoCircleOutlined
                                            onClick={() => setOpenPaymentAutomationControlModal(true)}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      </Space>
                                    </Tag>
                                    {openPaymentAutomationControlModal && (
                                      <ControlPaymentAutomation
                                        application_id={adminApplication._id}
                                        appkey={adminApplication.app_key}
                                        open={openPaymentAutomationControlModal}
                                        onClose={() => setOpenPaymentAutomationControlModal(false)}
                                        refetch={() =>
                                          queryClient.invalidateQueries({
                                            queryKey: ["application"],
                                          })
                                        }
                                      />
                                    )}
                                  </>
                                ) : null}
                                {/* {paymentTable.data?.payment_table?.[0]?.status === TRANSACTION_STATUS.PROPOSED && (
                                  <>
                                    <Button
                                      type="primary"
                                      danger
                                      size="small"
                                      icon={<TbAutomation size={16} />}
                                      onClick={() => setOpenPaymentAutomationStartModal(true)}
                                    >
                                      Start Payment Automation
                                    </Button>
                                    <StartPaymentAutomationModal
                                      appkey={appKey!}
                                      applicationId={adminApplication._id}
                                      readiness={paymentReadinessApplication()}
                                      open={openPaymentAutomationStartModal}
                                      onClose={() => setOpenPaymentAutomationStartModal(false)}
                                    />
                                  </>
                                )} */}
                              </div>
                            </div>
                            <PaymentLedger
                              applicationId={fullApplication?.data?.application?._id}
                              loans={fullApplication?.data?.data?.application?.loans}
                              appKey={appKey}
                              refetchData={() => fullApplication.refetch()}
                            />
                          </div>
                        ) : (
                          <SectionError className="h-[40vh]">
                            <SectionError.Text>First choose a relief plan to view the payment ledger</SectionError.Text>
                            <SectionError.Button
                              onClick={() => navigate(`/dashboard/application/strategy/${adminApplication.app_key}`)}
                            >
                              Select Strategy
                            </SectionError.Button>
                          </SectionError>
                        ),
                      },
                      {
                        key: "agreements",
                        label: "Agreements",
                        icon: <TbFileInvoice className="min-w-4" />,
                        children: isAllDetailsPrersent ? (
                          <div className="border border-solid border-gray-200 rounded-lg">
                            <div className="flex flex-col gap-2">
                              <div>
                                <div className="mx-3 my-3 flex items-center justify-between">
                                  <Typography.Title level={5} style={{ margin: 0 }}>
                                    Agreement Files
                                  </Typography.Title>
                                  <div className="flex items-center gap-2">
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      color="purple"
                                      icon={<TbSignature />}
                                      onClick={() => setOpenPDLinksModal(true)}
                                    >
                                      Get Signature Links
                                    </Button>
                                    <CopyPDLinks
                                      open={openPDLinksModal}
                                      onClose={() => setOpenPDLinksModal(false)}
                                      links={
                                        getclearApplication.external_links.pandadoc?.flatMap((p) => p.recipients) ?? []
                                      }
                                    />
                                    <Button
                                      icon={<TbEye />}
                                      size="small"
                                      variant="outlined"
                                      color="purple"
                                      onClick={handlePreview}
                                    >
                                      Preview PandaDoc
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        setIsLoanUploadModalOpen(true);
                                        setUploadType("agreements");
                                      }}
                                      icon={<TbUpload />}
                                      size="small"
                                      variant="outlined"
                                      color="purple"
                                    >
                                      Upload Agreements
                                    </Button>
                                  </div>
                                </div>
                                <Modal
                                  open={isPreviewOpen}
                                  onCancel={() => setIsPreviewOpen(false)}
                                  footer={null}
                                  width="70%"
                                  centered
                                  title={
                                    <div className="flex justify-between items-center">
                                      <Typography>Preview PandaDoc Agreement</Typography>
                                      <div className="flex items-center gap-2">
                                        <Popconfirm
                                          title="Regenerate PandaDoc?"
                                          description="This will allow the client to start a new PandaDoc process."
                                          okText="Reset"
                                          cancelText="Cancel"
                                          onConfirm={handleResetPandaDoc}
                                          okButtonProps={{ loading: resetPandaDoc.isPending }}
                                        >
                                          <Button icon={<TbRestore />} size="small" variant="outlined" color="purple">
                                            Regenerate PandaDoc
                                          </Button>
                                        </Popconfirm>
                                        <Button
                                          icon={<TbSend />}
                                          size="small"
                                          variant="outlined"
                                          color="purple"
                                          className="mr-8"
                                          onClick={handleInitiatePandaDoc}
                                          loading={initiatePandaDoc.isPending}
                                          disabled={initiatePandaDoc.isPending}
                                        >
                                          Send Signature Mail
                                        </Button>
                                      </div>
                                    </div>
                                  }
                                >
                                  {previewHtml && (
                                    <iframe
                                      key={iframeKey}
                                      srcDoc={previewHtml}
                                      style={{ width: "100%", height: "80vh", border: "none" }}
                                    />
                                  )}
                                </Modal>
                                <List
                                  className="mx-3 mb-3"
                                  dataSource={getclearApplication?.agreements ?? []}
                                  renderItem={(item, i) => {
                                    const fileName = item?.original_file_name ?? "";

                                    const docId = fileName?.split("_")?.[1]?.replace(".pdf", "");

                                    const pandaDocAgreement = getclearApplication?.external_links?.pandadoc?.find(
                                      (el) => el?.doc_id === docId,
                                    );

                                    const isPandaDoc = !!pandaDocAgreement;

                                    return (
                                      <List.Item key={item?._id}>
                                        <div className="inline-flex gap-2 items-baseline">
                                          <Tooltip title={pandaDocAgreement?.name ?? fileName}>
                                            <Typography.Text
                                              ellipsis
                                              style={{
                                                maxWidth: 460,
                                                display: "inline-block",
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {pandaDocAgreement?.name ?? fileName ?? `Agreement ${i + 1}`}
                                            </Typography.Text>
                                          </Tooltip>

                                          {isPandaDoc ? (
                                            <>
                                              <Tag
                                                color={
                                                  {
                                                    "document.completed": "green",
                                                    "document.sent": "blue",
                                                    "document.draft": "default",
                                                  }[pandaDocAgreement?.status]
                                                }
                                              >
                                                PANDADOC{" "}
                                                {pandaDocAgreement?.status?.replace("document.", "")?.toUpperCase()}
                                              </Tag>

                                              {/* <Tag color="purple">PANDADOC PROCESSED</Tag> */}
                                            </>
                                          ) : (
                                            <Tag color="orange">MANUAL UPLOAD</Tag>
                                          )}
                                        </div>

                                        <div className="flex items-center gap-2">
                                          <ViewFileBtn appKey={getclearApplication?.app_key} fileId={item?._id} />

                                          {/* <Popover
                                        content={
                                          <Form layout="vertical">
                                            <Form.Item
                                              label="Enter the email to whom you want to share the agreement"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Please input an email address",
                                                  type: "email",
                                                },
                                              ]}
                                            >
                                              <Input />
                                            </Form.Item>
                                          </Form>
                                        }
                                      >
                                        <Button icon={<TbDotsVertical />} />
                                      </Popover> */}
                                        </div>
                                      </List.Item>
                                    );
                                  }}
                                />
                              </div>
                              <GetPandaDocFile
                                appkey={appKey!}
                                pandadoc={getclearApplication.external_links.pandadoc}
                              />
                            </div>
                          </div>
                        ) : (
                          <SectionError className="h-[40vh]">
                            <SectionError.Text>
                              Please complete your Business Details and Client Details before proceeding. These fields
                              are required to continue with Pandadoc agreements.
                            </SectionError.Text>
                            <SectionError.Button
                              onClick={() => {
                                syncBusinessInfo.mutate(
                                  { appKey: appKey },
                                  {
                                    onSuccess: (data) => {
                                      const params = new URLSearchParams({ step: "3" });
                                      params.set("stopLoading", String(data.result.stopLoading));

                                      if (appKey) params.set("appkey", appKey);

                                      if (adminApplication.meta.email) params.set("email", adminApplication.meta.email);
                                      if (adminApplication.meta.phone) params.set("phone", adminApplication.meta.phone);
                                      if (adminApplication.meta.client_name)
                                        params.set("name", adminApplication.meta.client_name);

                                      navigate(`/dashboard/create-application?${params.toString()}`);
                                    },
                                  },
                                );
                              }}
                            >
                              Fill Details
                            </SectionError.Button>
                          </SectionError>
                        ),
                      },
                      {
                        key: "notes",
                        label: "Notes",
                        icon: <TbNote className="min-w-4" />,
                        children: (
                          <div className="">
                            <div>
                              <RichTextEditor
                                value={noteText}
                                onChange={(val) => {
                                  setNoteText(val);
                                }}
                                autoSave={(val) => {
                                  writeNote.mutate({ appkey: adminApplication?.app_key, notes: val });
                                }}
                              />
                            </div>
                            <div className="flex justify-end mt-2">
                              {writeNote.isPending ? (
                                <Typography.Text type="secondary" className="text-xs inline-flex items-center gap-1">
                                  <span className="inline-block w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                                  Saving...
                                </Typography.Text>
                              ) : writeNote.isSuccess ? (
                                <Typography.Text type="success" className="text-xs inline-flex items-center gap-1">
                                  <TbCheck className="text-green-600" />
                                  Auto-saved
                                </Typography.Text>
                              ) : null}
                            </div>
                          </div>
                        ),
                      },

                      {
                        key: "apr",
                        label: "Insights",
                        icon: <TbGraph className="min-w-4" />,
                        children:
                          optionsQuery.isPending || runReport.isPending ? (
                            <div className="flex justify-center w-full py-12">
                              <TbLoader2 className="stroke-purple-600 animate-spin" size={48} />
                            </div>
                          ) : (
                            <div className="flex items-center justify-between">
                              <div className="flex flex-col gap-0 !w-full">
                                {/* Switch is outside both views — always visible when iframeUrl exists */}
                                {iframeUrl && (
                                  <div className="flex w-full items-center justify-between px-1">
                                    <div className="flex items-center gap-2">
                                      <span className="text-sm text-gray-600">APR Page Version:</span>
                                      <Switch
                                        checked={showIframe}
                                        onChange={setShowIframe}
                                        checkedChildren="New"
                                        unCheckedChildren="Old"
                                      />
                                      <span className="text-sm text-purple-400 italic">
                                        New Insight Page may take some time to load and have Beta KPIs as well. Use with
                                        caution!
                                      </span>
                                    </div>

                                    {showIframe && (
                                      <Tooltip title={isFullscreen ? "Exit full screen" : "Open in full screen"}>
                                        <Button
                                          onClick={toggleFullscreen}
                                          type="text"
                                          icon={isFullscreen ? <TbMinimize size={16} /> : <TbMaximize size={16} />}
                                        ></Button>
                                      </Tooltip>
                                    )}
                                  </div>
                                )}

                                {iframeUrl && showIframe ? (
                                  <div
                                    ref={iframeContainerRef}
                                    style={{ width: "100%", height: isFullscreen ? "100vh" : 600, background: "#fff" }}
                                  >
                                    {isFullscreen && (
                                      <div
                                        className="absolute top-0 left-0 w-full h-16 z-10 flex items-start justify-center px-4 py-3
                   opacity-0 hover:opacity-100 transition-opacity duration-200
                   bg-gradient-to-b from-black/50 to-transparent"
                                      >
                                        <Tooltip title="Exit full screen">
                                          <Button
                                            onClick={toggleFullscreen}
                                            type="text"
                                            shape="circle"
                                            icon={<TbX size={20} className="text-white" />}
                                            className="!bg-black/30 hover:!bg-black/60"
                                          />
                                        </Tooltip>
                                      </div>
                                    )}
                                    <iframe
                                      src={iframeUrl}
                                      width="100%"
                                      height="100%"
                                      frameBorder="0"
                                      title="Datasense Insight"
                                    />
                                  </div>
                                ) : fullApplicationData.data.application.strategy &&
                                  fullApplicationData.data.application.strategy.plan !== "" ? (
                                  <GraphLoader
                                    application={fullApplicationData.data.application}
                                    hide={
                                      fullApplication.data?.data.application.bank_fetch_via === BankFetchMethod.PLAID
                                    }
                                  />
                                ) : (
                                  <div className="py-12 flex justify-center">
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No strategy selected" />
                                  </div>
                                )}
                              </div>
                              {/* {showIframe && (
                                <Tooltip title={isFullscreen ? "Exit full screen" : "Open in full screen"}>
                                  <Button
                                    onClick={toggleFullscreen}
                                    type="text"
                                    icon={isFullscreen ? <TbMinimize size={16} /> : <TbMaximize size={16} />}
                                  ></Button>
                                </Tooltip>
                              )} */}
                            </div>
                          ),
                      },
                      {
                        key: "tasks",
                        label: "Tasks",
                        icon: <TbClipboardCheck className="min-w-4" />,
                        children: (
                          <TaskBoardTab
                            selector={appKey!}
                            resource={Resource.APPLICATION}
                            orgCode={fullApplication.data?.application.organisation?.code}
                          />
                        ),
                      },
                      {
                        key: "team",
                        label: "Team",
                        icon: <TbUsersGroup className="min-w-4" />,
                        children: (
                          <TeamSection initialMeetings={fullApplicationData.application.meetings} appKey={appKey} />
                        ),
                      },
                      {
                        key: "misc-files",
                        label: "Misc Files",
                        icon: <TbFiles className="min-w-4" />,
                        children: (
                          <MiscFiles
                            referenceId={fullApplicationData.application._id}
                            mode="application"
                            loans={getclearApplication.loans.map((l) => {
                              return {
                                _id: l._id,
                                name: l.creditor_name,
                                funded_amount: l.funded_amount,
                                creditor_id: l.creditor_id,
                              };
                            })}
                          />
                        ),
                      },
                      ...(unChangedForeCastData.length !== 0
                        ? [
                            {
                              key: "forecast",
                              label: "Forecast Data",
                              icon: <LuChartLine className="min-w-4" />,
                              children: (
                                <div className="flex flex-col gap-6">
                                  <div className="border border-solid border-gray-200 rounded-lg">
                                    <Typography.Title level={5} className="mx-3 my-3">
                                      Forecast Graphs
                                    </Typography.Title>
                                    <div className="grid grid-cols-3 gap-3 p-3">
                                      {Object.entries(ForecastTypes).map(([key, value]) => {
                                        const isRegen = value === ForecastTypes.REGENERATE_CHARTS;
                                        return (
                                          <Button
                                            key={value}
                                            block
                                            size="large"
                                            icon={isRegen ? <TbRefresh /> : null}
                                            onClick={() => handleMenuClick({ key: value } as any)}
                                            className="flex items-center justify-center h-16 text-base font-medium"
                                          >
                                            {toTitleCase(key, { sep: "_", forceLower: true })}
                                          </Button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              ),
                            },
                          ]
                        : []),
                    ]}
                  />
                </div>
              </Splitter.Panel>

              <Splitter.Panel className="bg-gray-100" defaultSize={250} min={"180"} max={"25%"}>
                <div className="flex flex-col gap-3 p-3" style={{ minHeight: "calc(100vh - 50px)" }}>
                  <>
                    {/* {getclearApplication?.external_links?.pandadoc &&
                    getclearApplication?.external_links?.pandadoc?.length > 0 ? (
                      <div className="py-2 pl-2 pr-4 text-emerald-800 bg-emerald-200 border border-solid border-emerald-300 inline-flex items-center gap-2 rounded-full uppercase tracking-wider font-semibold text-xs">
                        {
                          getclearApplication.external_links.pandadoc.filter(
                            (el: any) => el?.status === "document.completed",
                          ).length
                        }{" "}
                        / {getclearApplication.external_links.pandadoc.length} Agreements Signed
                      </div>
                    ) : null} */}

                    {/* <div className="min-w-[160px]">
                      <div className="flex flex-col">
                        <Typography.Text
                          type="secondary"
                          className="p-2 border-b border-solid border-gray-200 bg-gray-50 w-full text-center rounded-t-lg text-xs"
                        >
                          Last Step Completed
                        </Typography.Text>

                        <Typography.Text className="font-semibold p-2 uppercase tracking-wider w-full text-center bg-white border border-t-0 border-solid border-gray-200 rounded-b-lg text-sm">
                          {String(getclearApplication?.status?.last_step ?? "-")
                            .split("_")
                            .join(" ")}
                        </Typography.Text>
                      </div>
                    </div> */}
                  </>

                  {/* {selectedApplication?.status.last_step ? selectedApplication?.status.last_step : "-"} */}
                  {/* <div className="flex flex-col">
                    <Typography.Text
                      type="secondary"
                      className="p-2 border border-solid border-gray-200 bg-gray-50 w-full text-center rounded-t-lg"
                    >
                      Summary
                    </Typography.Text>
                    <div className="p-3 bg-white border border-t-0 border-solid border-gray-200 rounded-b-lg">

                      <div>
                        <ApplicationDetails
                          selectedLead={{
                            enrolled_debt: getclearApplication?.summary?.current_debt,
                            last_step: getclearApplication?.status?.last_step,
                            onboarding_completed: getclearApplication?.status?.onboarding,
                            total_banks: getclearApplication?.banks?.length,
                            total_lawsuits: getclearApplication?.lawsuits?.length,
                            total_loans: getclearApplication?.loans?.length,
                          }}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="flex flex-col mt-2">
                    <div className="mb-4 flex flex-col gap-2">
                      {adminApplication?.app_key && (
                        <div
                          className={
                            "border border-purple-600 bg-purple-100 border-solid rounded-md inline-flex items-center gap-1 px-2.5 py-1 "
                          }
                        >
                          <Typography.Text type="secondary">APPKEY : </Typography.Text>
                          <span>{adminApplication.app_key}</span>

                          {isCopied && copyKey === "appkey" ? (
                            <TbClipboardCheck
                              key="copied-icon"
                              className="stroke-green-500 cursor-pointer flex-shrink-0 ml-1"
                            />
                          ) : (
                            <Tooltip title="Copy">
                              <TbCopy
                                className="cursor-pointer flex-shrink-0 ml-1"
                                color="#7f65f1"
                                onClick={(e) => {
                                  setCopyKey("appkey");
                                  setIsCopied(true);
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(adminApplication.app_key);
                                  setTimeout(() => {
                                    setIsCopied(false);
                                  }, 800);
                                }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                      <div>
                        <WalletTopupWidget applicationId={fullApplicationData.application._id} />
                        <WalletTopupModal
                          applicationId={fullApplicationData.application._id}
                          open={topupModal}
                          onClose={() => setTopupModal(false)}
                          key={`topup-${fullApplicationData.application._id}`}
                        />
                      </div>
                      <LogNavigator
                        options={[
                          {
                            to: `/dashboard/transaction-logs?application_id=${fullApplicationData.application._id}&wallet_type=${WalletTypes.APPLICATION}`,
                            label: "Application Transaction Logs",
                          },
                          {
                            to: `/dashboard/transaction-logs?org_id=${fullApplicationData.application.organisation?._id}&wallet_type=${WalletTypes.ORG_PROGRAM_FEE}`,
                            label: "Organisation Program Fee Logs",
                          },
                          {
                            to: `/dashboard/transaction-logs?org_id=${fullApplicationData.application.organisation?._id}&wallet_type=${WalletTypes.ORG_LEGAL_FEE}`,
                            label: "Organisation Legal Fee Logs",
                          },
                          {
                            to: `/dashboard/transaction-logs?org_id=${fullApplicationData.application.organisation?._id}&wallet_type=${WalletTypes.ORG_SERVICE_FEE}`,
                            label: "Organisation Service Fee Logs",
                          },
                        ]}
                      />
                      <Button
                        color="cyan"
                        variant="outlined"
                        icon={<TbEyeDollar />}
                        onClick={() => {
                          if (!fullApplicationData.data.application.status.signatures) {
                            message.warning("Application has not complete document signatures yet.");
                            // return
                          }

                          setOpenPaymentMethodModal(true);
                        }}
                      >
                        Add Payment Methods
                      </Button>
                    </div>
                    <Typography.Text
                      type="secondary"
                      className="p-2 uppercase border border-solid !text-pink-500 border-pink-500 bg-gray-50 w-full text-center rounded-t-lg"
                    >
                      Strategy
                    </Typography.Text>

                    {adminApplication.plan?.key ? (
                      <>
                        <div
                          className={`p-3 bg-white border border-y-0 border-solid border-x-pink-500 border-gray-200 ${getclearApplication.strategy_type === StrategyType.PERCENTAGE ? "border-b rounded-b-lg border-b-pink-500" : ""}`}
                        >
                          <Space className="items-center mb-2">
                            {strategyOrg && (
                              <Tooltip title={strategyOrg.custom ? "Custom Plan" : (strategyOrg.name ?? null)}>
                                <Avatar
                                  size={24}
                                  src={strategyOrg.logo}
                                  className={strategyOrg.custom ? "bg-purple-500" : undefined}
                                >
                                  {strategyOrg.custom ? (
                                    <TbTools />
                                  ) : (
                                    (strategyOrg.name?.at(0) ?? "U")?.toLocaleUpperCase()
                                  )}
                                </Avatar>
                              </Tooltip>
                            )}
                            <Typography.Title level={4} className="!leading-none !m-0">
                              {adminApplication.plan.key}
                            </Typography.Title>
                          </Space>
                          <StrategyPlanDetails
                            planDetails={{
                              totalDebt:
                                getclearApplication.summary.current_debt ||
                                adminApplication.enrolled_debt ||
                                adminApplication.summary?.current_debt,
                              initial_payment: adminApplication.plan?.initial_payment,
                              weekly_payments: adminApplication.plan?.weekly_payments,
                              tenure: adminApplication.plan?.tenure,
                              lawsuit_initial_payment: adminApplication.plan?.lawsuit_initial_payment,
                              lawsuit_monthly_payment: adminApplication.plan?.lawsuit_monthly_payment,
                              mode: adminApplication.strategy_type || StrategyType.STANDARD,
                            }}
                          />
                        </div>
                        {getclearApplication.strategy_type === StrategyType.PERCENTAGE ? null : (
                          <Button
                            type="primary"
                            variant="solid"
                            color="magenta"
                            className="rounded-t-none border border-solid border-pink-500 rounded-b-lg"
                            onClick={() => navigate(`/dashboard/application/strategy/${appKey}`)}
                          >
                            View All Strategies
                          </Button>
                        )}
                      </>
                    ) : (
                      <div className="bg-white">
                        <div className="flex flex-col h-[352px] items-center justify-center gap-3 py-6 px-4 text-center border border-y-0 border-solid border-x-pink-500 border-gray-200">
                          <div className="flex flex-col items-center justify-between">
                            <Typography.Text strong className="!text-base">
                              Total Debt{" "}
                            </Typography.Text>
                            <Typography.Text strong className="!text-3xl !font-semibold">
                              {formatMoney(
                                getclearApplication.summary.current_debt ||
                                  adminApplication.enrolled_debt ||
                                  adminApplication.summary?.current_debt,
                              )}
                            </Typography.Text>
                          </div>
                          <div className="size-10 rounded-full bg-pink-50 border border-solid border-pink-200 flex items-center justify-center">
                            <TbChessKnight size={20} className="text-pink-400" />
                          </div>
                          <div className="flex flex-col gap-1">
                            <Typography.Text className="font-semibold text-gray-700">
                              No Strategy Selected
                            </Typography.Text>
                            <Typography.Text type="secondary" className="text-xs">
                              Assign a relief strategy to generate the payment ledger
                            </Typography.Text>
                          </div>
                        </div>
                        <Button
                          type="primary"
                          variant="solid"
                          color="magenta"
                          block
                          className="rounded-t-none border border-solid border-pink-500 rounded-b-lg"
                          icon={<TbChevronRight size={16} />}
                          onClick={() => navigate(`/dashboard/application/strategy/${appKey}`)}
                        >
                          Select Strategy
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* <button
                    className={styles.aiButton}
                    onClick={() => navigate(`/dashboard/application/background-logs/${appKey}`)}
                  >
                    <span className={styles.shimmer}></span>

                    <TbFileText className={styles.icon} size={18} />

                    <span className={styles.label}>Worker Logs</span>
                  </button> */}
                  <Button
                    icon={<TbFileText />}
                    color="orange"
                    variant="outlined"
                    onClick={() => navigate(`/dashboard/application/background-logs/${appKey}`)}
                  >
                    Worker Logs
                  </Button>
                </div>
              </Splitter.Panel>
            </Splitter>
          );
        }}
      />
      <Drawer
        size="large"
        title={
          <div className="flex justify-between items-center">
            <p>Finanical Impact Analysis Report</p>
            <Button
              disabled={generateFIAReport.isPending}
              loading={generateFIAReport.isPending}
              onClick={() => {
                generateFIAReport.mutate(appKey!, {
                  onSuccess: () => {
                    const msg = `FIA ${hasFIAReport ? "regeneration" : "generation"} has started. Please wait 5 minutes.`;

                    message.success(msg);
                  },
                });
              }}
              type="primary"
            >
              {hasFIAReport ? "Regenerate Report" : "Generate Report"}
            </Button>
          </div>
        }
        closable={{ "aria-label": "Close Button" }}
        onClose={() => setIsFIADrawerOpen(false)}
        open={isFIADrawerOpen}
      >
        <div className={styles.fia_report}>
          {hasFIAReport ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{fiaReport.data.result.content}</ReactMarkdown>
          ) : (
            "No FIA report available yet."
          )}
        </div>
      </Drawer>
      <Modal
        title="Select specific section"
        open={openModal}
        onOk={handleSubmitForm}
        onCancel={handleModalClose}
        width={800}
      >
        <Form<T_Form> form={form} layout="vertical">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <Form.Item name="check1" valuePropName="checked" className="!mb-2">
                <Checkbox>Revenue and Cashflow Trends</Checkbox>
              </Form.Item>
              {check1 && (
                <Form.Item name="revenue_cashflow">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
            <div className="col-span-6">
              <Form.Item name="check2" valuePropName="checked" className="!mb-2">
                <Checkbox>Table summaries and MCA Contracts Overview</Checkbox>
              </Form.Item>
              {check2 && (
                <Form.Item name="mca_contracts">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <Form.Item name="check3" valuePropName="checked" className="!mb-2">
                <Checkbox>Expenditure and Liquidity Analysis</Checkbox>
              </Form.Item>
              {check3 && (
                <Form.Item name="liquidity_analysis">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
            <div className="col-span-6">
              <Form.Item name="check4" valuePropName="checked" className="!mb-2">
                <Checkbox>Financial Stability and Risk Indicators</Checkbox>
              </Form.Item>
              {check4 && (
                <Form.Item name="risk_indicators">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <Form.Item name="check5" valuePropName="checked" className="!mb-2">
                <Checkbox>Loan Repayment Capacity</Checkbox>
              </Form.Item>
              {check5 && (
                <Form.Item name="loan_repayment">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
            <div className="col-span-6">
              <Form.Item name="check6" valuePropName="checked" className="!mb-2">
                <Checkbox>Credit Memo and General Audit</Checkbox>
              </Form.Item>
              {check6 && (
                <Form.Item name="credit_memo">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <Form.Item name="check7" valuePropName="checked" className="!mb-2">
                <Checkbox>Conclusions and Recommendations</Checkbox>
              </Form.Item>
              {check7 && (
                <Form.Item name="recommendations">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
            <div className="col-span-6">
              <Form.Item name="check8" valuePropName="checked" className="!mb-2">
                <Checkbox>Key Trends and Debt analysis for Client</Checkbox>
              </Form.Item>
              {check8 && (
                <Form.Item name="debt_analysis">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <Form.Item name="check9" valuePropName="checked" className="!mb-2">
                <Checkbox>Final Conclusions and Auditor’s Remark</Checkbox>
              </Form.Item>
              {check9 && (
                <Form.Item name="final_conclusion">
                  <Input.TextArea cols={4} />
                </Form.Item>
              )}
            </div>
          </div>
        </Form>
      </Modal>
      <Modal
        centered
        footer={null}
        title={foreCastModalTitle}
        open={openForeCastedModal}
        // onOk={handleSubmitForm}
        onCancel={() => setOpenForeCastedModal(false)}
        width={1000}
        height={700}
      >
        {foreCastData && foreCastData.length === 0 ? (
          <Typography.Title level={5}>
            We are still processing this data , please comeback after few minutes
          </Typography.Title>
        ) : (
          <SingleQueryWrapper
            query={foreCast}
            renderData={(foreCast) => {
              return combinedData.length === 0 ? (
                <div className="h-full w-full flex justify-center items-center">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data found" />
                </div>
              ) : (
                <div>
                  <ResponsiveContainer width="100%" height={500}>
                    <LineChart data={combinedData} margin={{ top: 5, right: 50, left: 20, bottom: 5 }}>
                      <XAxis
                        dataKey="uv"
                        // tickFormatter={(tick) => dayjs(tick).format("MMM")}
                        tick={<CustomTick />}
                        interval="preserveEnd"
                        // angle={-45}
                        allowDuplicatedCategory={false}
                      />
                      <YAxis />

                      <ReTooltip content={<CustomTooltip />} />

                      <Brush
                        dataKey="uv"
                        height={30}
                        stroke="#8884d8"
                        tickFormatter={(tick) => dayjs(tick).format("MMM")}
                      />

                      {combinedData.length > 0 && !hiddenSeries.includes("originalData") && (
                        <Line
                          name="Original Data"
                          type="monotone"
                          dataKey="originalData"
                          stroke="#8884d8"
                          activeDot={{ r: 8 }}
                          connectNulls={false}
                        />
                      )}

                      {combinedData.length > 0 && !hiddenSeries.includes("forecastedData") && (
                        <Line
                          name="Forecasted Data"
                          type="monotone"
                          dataKey="forecastedData"
                          stroke="#fcba03"
                          activeDot={{ r: 8 }}
                          connectNulls={false}
                        />
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                  {combinedData.length > 0 && (
                    <CustomLegend
                      payload={[
                        { value: "Original Data", color: "#8884d8", dataKey: "originalData" },
                        { value: "Forecasted Data", color: "#fcba03", dataKey: "forecastedData" },
                      ]}
                      onToggle={toggleSeries}
                      hiddenSeries={hiddenSeries}
                    />
                  )}
                </div>
              );
            }}
          />
        )}
      </Modal>
      {/**Category Modal */}
      <Modal
        centered
        title={"Categoty Forecast"}
        footer={null}
        open={openCategoryModal}
        onCancel={() => setOpenCategoryModal(false)}
        width={1200}
        height={700}
      >
        <div>
          {categoryForeCast && categoryForeCast.length === 0 ? (
            <Typography.Title level={5}>
              We are still processing this data , please comeback after few minutes
            </Typography.Title>
          ) : (
            categoryForeCast &&
            categoryForeCast.length > 0 && (
              <Tabs
                size="small"
                more={{ icon: <TbChevronRight size={28} className="cursor-pointer" /> }}
                // tabBarExtraContent={<Button icon={<TbDots />}></Button>}
                activeKey={tabKey}
                items={categoryForeCast.map((categoryForecast, index) => ({
                  key: categoryForecast.title,
                  label: toTitleCase(categoryForecast.title),
                  children: (
                    <ResponsiveContainer width={"100%"} height={500} key={`responsive-container-${index}`}>
                      <LineChart data={combinedCategoryData} margin={{ top: 5, right: 50, left: 20, bottom: 5 }}>
                        <XAxis
                          dataKey="uv"
                          tick={<CustomTick />}
                          interval="preserveEnd"
                          angle={-45}
                          allowDuplicatedCategory={false}
                        />
                        <YAxis />

                        <ReTooltip content={<CustomTooltip />} />
                        {/* <Legend align="right" /> */}

                        <Brush
                          dataKey="uv"
                          height={30}
                          stroke="#8884d8"
                          tickFormatter={(tick) => dayjs(tick).format("MMM")}
                        />

                        {combinedCategoryData.length > 0 && !hiddenSeries.includes("originalData") && (
                          <Line
                            name="Original Data"
                            type="monotone"
                            dataKey="originalData"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                            connectNulls={false}
                          />
                        )}

                        {combinedCategoryData.length > 0 && !hiddenSeries.includes("forecastedData") && (
                          <Line
                            name="Forecasted Data"
                            type="monotone"
                            dataKey="forecastedData"
                            stroke="#fcba03"
                            activeDot={{ r: 8 }}
                            connectNulls={false}
                          />
                        )}
                      </LineChart>
                    </ResponsiveContainer>
                  ),
                }))}
                onChange={handleChangeTab}
              />
            )
          )}
        </div>
        {combinedCategoryData.length > 0 && (
          <CustomLegend
            payload={[
              { value: "Original Data", color: "#8884d8", dataKey: "originalData" },
              { value: "Forecasted Data", color: "#fcba03", dataKey: "forecastedData" },
            ]}
            onToggle={toggleSeries}
            hiddenSeries={hiddenSeries}
          />
        )}
      </Modal>
      {/**V2 Modal */}
      <Modal width={1200} open={openv2Modal} onCancel={() => setOpenv2Modal(false)} footer={null}>
        {historical && forecast && backtest && historical.length > 0 && forecast.length > 0 && backtest.length > 0 ? (
          <div>
            <div ref={chartScrollRef} className="scroll-smooth" style={{ width: "100%", overflowX: "auto" }}>
              <div style={{ width: "1800px" }}>
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <div className="snap-x snap-mandatory scroll-smooth" style={{ width: chartWidth }}>
                    <ComposedChart width={chartWidth} height={420}>
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        dataKey="date"
                        scale="point"
                        tickFormatter={formatDate}
                        allowDuplicatedCategory={false}
                        minTickGap={20}
                      />

                      <YAxis />
                      <ReTooltip labelFormatter={formatDate} />
                      <Legend />

                      <Line
                        data={historical}
                        dataKey="value"
                        stroke="#2563eb"
                        strokeWidth={2}
                        dot={false}
                        isAnimationActive={false}
                      />

                      <Area
                        data={backtest}
                        dataKey="upper"
                        fill="#fca5a5"
                        fillOpacity={0.4}
                        stroke="none"
                        isAnimationActive={false}
                      />
                      <Area
                        data={backtest}
                        dataKey="lower"
                        fill="#fca5a5"
                        fillOpacity={0.4}
                        stroke="none"
                        isAnimationActive={false}
                      />

                      <Line
                        data={backtest}
                        dataKey="value"
                        stroke="#dc2626"
                        strokeWidth={2}
                        dot={false}
                        isAnimationActive={false}
                      />

                      <Area
                        data={forecast}
                        dataKey="upper"
                        fill="#fde68a"
                        fillOpacity={0.5}
                        stroke="none"
                        isAnimationActive={false}
                      />
                      <Area
                        data={forecast}
                        dataKey="lower"
                        fill="#fde68a"
                        fillOpacity={0.4}
                        stroke="none"
                        isAnimationActive={false}
                      />

                      <Line
                        data={forecast}
                        dataKey="value"
                        stroke="#f59e0b"
                        strokeWidth={2}
                        dot={false}
                        isAnimationActive={false}
                      />
                    </ComposedChart>
                  </div>
                </div>
              </div>
            </div>

            <CustomLegendV2
              scrollContainerRef={chartScrollRef}
              payload={[
                { value: "Historical Data", color: "#2563eb", dataKey: "historical" },
                { value: "Backtest Data", color: "#dc2626", dataKey: "backtest" },
                { value: "Forecast Data", color: "#f59e0b", dataKey: "forecast" },
              ]}
            />
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <Typography.Title className="!max-w-xl !text-center" level={5}>
              We are still processing the data , please wait for a moment
            </Typography.Title>
          </div>
        )}
      </Modal>
      {fullApplication.data ? (
        <PaymentModal
          paymentTable={fullApplication.data?.application.payment_table}
          refetchPaymentTable={() => {
            queryClient.refetchQueries({
              queryKey: ["application/payment-table", fullApplication?.data?.application?._id],
            });
          }}
          openPaymentModal={openPaymentModal}
          handleOpenPaymentModal={() => setOpenPaymentModal(false)}
          fullApplication={fullApplication?.data}
        />
      ) : null}
      {isOpen && <CustomModal isOpen={isOpen} onClose={() => setIsOpen(false)} appkey={appKey} />}
      {isPandaDocModalOpen && appKey ? (
        <PandaDocModal
          appKey={appKey}
          isOpen={isPandaDocModalOpen}
          setIsOpen={setIsPandaDocModalOpen}
          pandaDocs={fullApplication?.data?.data?.application?.external_links?.pandadoc}
        />
      ) : null}
      <SmartNegotiationPanel
        isOpen={isNegotiationPanelOpen}
        onClose={() => setIsNegotiationPanelOpen(false)}
        negotiationContext={smartNegotiationContext}
        isShowInDrawer={true}
      />
      {isResetModalOpen && appKey && fullApplication?.data?.data?.application?.status ? (
        <ResetModal
          appKey={appKey}
          isOpen={isResetModalOpen}
          onClose={() => setIsResetModalOpen(false)}
          status={fullApplication?.data?.data?.application?.status}
        />
      ) : null}
      {isChangeStatusModalOpen && appKey && fullApplication?.data?.data?.application?.status ? (
        <ChangeStatusModal
          appKey={appKey}
          isOpen={isChangeStatusModalOpen}
          onClose={() => setIsChangeStatusModalOpen(false)}
          status={fullApplication?.data?.data?.application?.status}
        />
      ) : null}
      <Modal
        title="Link Creditor"
        open={openLinkCreditor}
        onCancel={() => {
          linkCreditorForm.resetFields();
          setSelectedLoan(undefined);
          setOpenLinkCreditor(false);
        }}
        width={520}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              linkCreditorForm.resetFields();
              setSelectedLoan(undefined);
              setOpenLinkCreditor(false);
            }}
          >
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => linkCreditorForm.submit()}>
            Link Creditor
          </Button>,
        ]}
      >
        <Form
          form={linkCreditorForm}
          layout="vertical"
          initialValues={{
            creditor_id: selectedLoan?.creditor_id,
            partner_creditor_id: selectedLoan?.partner_creditor_id,
          }}
          onFinish={(values) => {
            linkCreditor.mutate(
              {
                loan_id: selectedLoan?._id ?? "",
                creditor_id: values.creditor_id,
                partner_creditor_id: values.partner_creditor_id,
              },
              {
                onSuccess: () => {
                  message.success(`Creditor linked succesfully.`);
                  fullApplication.refetch();
                  setSelectedLoan(undefined);
                  setOpenLinkCreditor(false);
                },
              },
            );
          }}
        >
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-start justify-between gap-3 mb-1">
                <div className="text-xs font-medium uppercase tracking-wide text-gray-500">Provided Creditor Name</div>

                <Tag
                  className="!m-0 px-2 py-0.5 text-xs font-medium capitalize"
                  color={
                    selectedLoan?.creditor_match === CreditorMatchSync.MATCHED
                      ? "green"
                      : selectedLoan?.creditor_match === CreditorMatchSync.PROBABLE
                        ? "yellow"
                        : "red"
                  }
                >
                  {selectedLoan?.creditor_match
                    ? `${selectedLoan.creditor_match.toUpperCase()} ${selectedLoan?.creditor_match === CreditorMatchSync.MATCHED ? "" : "MATCH"}`
                    : "NOT LINKED"}
                </Tag>
              </div>

              <div className="text-base font-semibold text-gray-900">{selectedLoan?.creditor_name || "-"}</div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-medium text-gray-500">POTENTIAL MATCHES</div>
                <Button size="small" icon={<TbReload />} type="primary" onClick={() => allCreditors.refetch()}>
                  Refetch
                </Button>
              </div>

              <div className="text-sm text-gray-800 leading-relaxed">
                {(() => {
                  const matches = fuzzyMatch(
                    creditorNames.filter((c) => c.isPartner === false).map((c) => c.name),
                    selectedLoan?.creditor_name ?? "",
                  );

                  if (!matches || matches.length === 0) {
                    return <span className="text-gray-400">No close matches found</span>;
                  }

                  return matches.slice(0, 5).map((name) => (
                    <div key={name} className="flex items-center justify-between gap-2 py-1">
                      <span className="font-medium truncate">{name}</span>

                      <TbArrowsExchange
                        size={14}
                        className="cursor-pointer text-purple-600 hover:text-purple-800"
                        onClick={() => {
                          const creditorId = creditorNames.find((c) => c.name === name)?.id;

                          if (!creditorId) {
                            message.warning("Creditor not found in list");
                            return;
                          }

                          linkCreditorForm.setFieldsValue({
                            creditor_id: creditorId,
                          });

                          message.success(`Selected "${name}"`);
                        }}
                      />
                    </div>
                  ));
                })()}
              </div>
            </div>

            <Form.Item
              name="creditor_id"
              label="Link to existing creditor"
              rules={[{ required: true, message: "Select a creditor" }]}
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                placeholder="Search or create creditor"
                onSearch={(value) => setNewCreditorName(value)}
                options={allCreditorsData
                  .filter((c) => !c.isPartner)
                  .map((c) => ({
                    label: c.name,
                    value: c._id,
                  }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}

                    {newCreditorName &&
                      !allCreditorsData.some(
                        (c) => c.name.toLowerCase() === newCreditorName.toLowerCase() && !c.isPartner,
                      ) && (
                        <div className="border-t border-gray-200 px-3 py-2">
                          <Button
                            type="text"
                            className="w-full text-left text-purple-600"
                            icon={<TbPlus size={14} />}
                            onClick={async () => {
                              addCreditor.mutate(
                                {
                                  dto: {
                                    name: newCreditorName,
                                    allowed_domains: [],
                                    allowed_emails: [],
                                    allowed_phones: [],
                                    alternate_names: [],
                                    slug: "",
                                    inDraft: false,
                                  },
                                  bypass: false,
                                },
                                {
                                  onSuccess: (created) => {
                                    message.success(`Creditor created`);

                                    allCreditors.refetch();

                                    linkCreditorForm.setFieldsValue({
                                      creditor_id: created.result._id,
                                    });

                                    setNewCreditorName("");
                                  },
                                },
                              );
                            }}
                          >
                            {`Create creditor “${newCreditorName}”`}
                          </Button>
                        </div>
                      )}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item name="partner_creditor_id" label="Link to existing partner creditor">
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                placeholder="Search or create partner creditor"
                onSearch={(value) => setNewPartnerCreditorName(value)}
                options={allCreditorsData
                  .filter((c) => c.isPartner === true)
                  .map((c) => ({
                    label: c.name,
                    value: c._id,
                  }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}

                    {newPartnerCreditorName &&
                      !allCreditorsData.some(
                        (c) => c.name.toLowerCase() === newPartnerCreditorName.toLowerCase() && c.isPartner === true,
                      ) && (
                        <div className="border-t border-gray-200 px-3 py-2">
                          <Button
                            type="text"
                            className="w-full text-left text-purple-600"
                            icon={<TbPlus size={14} />}
                            onClick={async () => {
                              addCreditor.mutate(
                                {
                                  dto: {
                                    name: newPartnerCreditorName,
                                    allowed_domains: [],
                                    allowed_emails: [],
                                    allowed_phones: [],
                                    alternate_names: [],
                                    slug: "",
                                    inDraft: false,
                                    isPartner: true,
                                  },
                                  bypass: false,
                                },
                                {
                                  onSuccess: (created) => {
                                    message.success(`Partner creditor created`);

                                    allCreditors.refetch();

                                    linkCreditorForm.setFieldsValue({
                                      partner_creditor_id: created.result._id,
                                    });

                                    setNewPartnerCreditorName("");
                                  },
                                },
                              );
                            }}
                          >
                            {`Create partner creditor “${newPartnerCreditorName}”`}
                          </Button>
                        </div>
                      )}
                  </>
                )}
              />
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <AddLoanModal
        appkey={appKey!}
        selectedLoan={selectedLoan}
        open={openCreditorModal}
        onClose={() => setOpenCreditorModal(false)}
        isPlanSelected={!!fullApplication.data?.application.plan?.key}
        isPriorApplication={fullApplication.data?.application?.isPriorApplication === true}
      />
      <EditableLedgerModal
        appKey={appKey!}
        applicationId={fullApplication.data?.application._id}
        open={openEditableLedgerModal}
        onClose={() => setOpenEditableLedgerModal(false)}
        loans={fullApplication?.data?.data?.application?.loans}
      />
      {/* <CreditorModal
        appkey={appKey!}
        selectedLoan={selectedLoan}
        open={openCreditorModal}
        onClose={() => setOpenCreditorModal(false)}
        isPlanSelected={!!fullApplication.data?.application.plan?.key}
        openUploadModal={() => {
          setIsLoanUploadModalOpen(true);
          setUploadType("loan");
        }}
      /> */}
      <UploadLoanModal
        isOpen={isLoanUploadModalOpen}
        onClose={() => setIsLoanUploadModalOpen(false)}
        uploadType={uploadType}
        appkey={appKey!}
        isPlanSelected={!!fullApplication.data?.application.plan?.key}
      />
      <BankModal
        appkey={appKey!}
        selectedBank={selectedBank}
        open={openEditBank}
        onClose={() => setOpenEditBank(false)}
      />
      <BusinessInfoUpdateModal
        appKey={appKey!}
        businessInfo={businessInfo}
        clientDetails={clientDetails}
        isOpen={isBusinessDetailsOpen}
        onClose={() => setIsBusinessDetailsOpen(false)}
        selectedBank={bankDetails}
      />
      <UploadLawSuitsModal
        appkey={appKey!}
        loanDetails={selectedLoan}
        isOpen={isLawSuitsUploadModalOpen}
        onClose={() => {
          setIsLawSuitsUploadModalOpen(false);
          setSelectedLoan(undefined);
        }}
      />
      <ExpectedPaymentBreakdown
        open={Boolean(analyzeLoan)}
        onClose={() => setAnalyzeLoan(undefined)}
        loan={analyzeLoan}
      />
      <LoanReconciliationDrawer
        appKey={appKey as string}
        selectedLoan={selectedLoan}
        open={isLoanPaymentTimelineDrawerOpen}
        onClose={() => setIsLoanPaymentTimelineDrawerOpen(false)}
        banks={fullApplication?.data?.data.application.banks ?? []}
      />
    </DashboardLayout>
  );
}

const CustomTick = (props: any) => {
  const { x, y, payload } = props;
  const currentDate = dayjs(payload.value);

  const shouldShowMonth =
    payload.index === 0 || dayjs(payload.value).format("MMM") !== dayjs(payload.previousValue || 0).format("MMM");

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#666" fontSize="12">
        {shouldShowMonth ? currentDate.format("MMM DD") : currentDate.format("DD")}
      </text>
    </g>
  );
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-4 border border-gray-300 rounded-lg shadow-lg min-w-[200px]">
        <div className="border-b border-gray-200">
          <Typography.Paragraph>{dayjs(label).format("DD MMM, YYYY")}</Typography.Paragraph>
        </div>
        <div className="space-y-1">
          {payload.map((entry: any, index: number) => (
            <div key={index} className="flex justify-between items-center">
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full mr-2" style={{ backgroundColor: entry.color }} />
                <Typography.Text className="text-gray-600 text-sm">{entry.name}:</Typography.Text>
              </div>
              <span className={`font-semibold text-gray-800 ${entry.value < 0 ? "text-red-600" : "text-green-600"}`}>
                {entry.value !== null ? `$${entry.value.toLocaleString()}` : "No Data"}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

const CustomLegend = ({
  payload,
  onToggle,
  hiddenSeries = [],
}: {
  payload: any;
  onToggle: (dataKey: string) => void;
  hiddenSeries: string[];
}) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 mt-4 p-3 bg-gray-50 rounded-lg">
      {payload.map((entry: any, index: number) => {
        const isHidden = hiddenSeries.includes(entry.dataKey);
        return (
          <Button
            key={index}
            onClick={() => onToggle(entry.dataKey)}
            className={`flex items-center gap-2 transition-all duration-200 ${
              isHidden ? "bg-gray-200 opacity-50" : "bg-white shadow-sm hover:shadow-md"
            }`}
          >
            <div
              className={`w-4 h-4 rounded-full transition-opacity ${isHidden ? "opacity-30" : "opacity-100"}`}
              style={{ backgroundColor: entry.color }}
            />
            <span className={`text-sm font-medium transition-opacity ${isHidden ? "text-gray-400" : "text-gray-700"}`}>
              {entry.value}
            </span>
          </Button>
        );
      })}
    </div>
  );
};

const CustomLegendV2 = ({
  payload,
  scrollContainerRef,
}: {
  payload?: Array<{
    value: string;
    color: string;
    dataKey?: string;
  }>;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
}) => {
  const localScrollRef = useRef<HTMLDivElement>(null);

  const handleScrollLeft = () => {
    const targetRef = scrollContainerRef || localScrollRef;
    if (targetRef.current) {
      targetRef.current.scrollBy({
        left: -400,
        behavior: "smooth",
      });
    }
  };

  const handleScrollRight = () => {
    const targetRef = scrollContainerRef || localScrollRef;
    if (targetRef.current) {
      targetRef.current.scrollBy({
        left: 400,
        behavior: "smooth",
      });
    }
  };

  if (!payload || payload.length === 0) return null;

  return (
    <div className="relative mt-4 px-3 py-2 bg-gray-50 rounded-lg">
      <div
        ref={localScrollRef}
        className="flex items-center gap-3 overflow-x-auto scroll-smooth scrollbar-hide"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {payload.map((entry, index) => (
          <div
            key={entry.dataKey ?? `${entry.value}-${index}`}
            className="flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-gray-200 flex-shrink-0"
          >
            <span className="w-3 h-3 rounded-full" style={{ backgroundColor: entry.color }} />
            <span className="text-sm font-medium text-gray-700">{entry.value}</span>
          </div>
        ))}
      </div>
      <div className="flex gap-1 absolute right-4 top-2 ">
        <Button size="small" icon={<TbChevronLeft />} onClick={handleScrollLeft} />
        <Button size="small" icon={<TbChevronRight />} onClick={handleScrollRight} />
      </div>
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};
